/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface ActionConnectionDto
 */
export interface ActionConnectionDto {
    /**
     * 
     * @type {string}
     * @memberof ActionConnectionDto
     */
    'nextActionId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionConnectionDto
     */
    'type': ActionConnectionDtoTypeEnum;
    /**
     * 
     * @type {Array<GenericConnectionDto>}
     * @memberof ActionConnectionDto
     */
    'connections'?: Array<GenericConnectionDto>;
}

export const ActionConnectionDtoTypeEnum = {
    Standard: 'standard',
    Branch: 'branch'
} as const;

export type ActionConnectionDtoTypeEnum = typeof ActionConnectionDtoTypeEnum[keyof typeof ActionConnectionDtoTypeEnum];

/**
 * 
 * @export
 * @interface ActionCreateRequest
 */
export interface ActionCreateRequest {
    /**
     * 
     * @type {ActionCreateRequestAction}
     * @memberof ActionCreateRequest
     */
    'action': ActionCreateRequestAction;
}
/**
 * @type ActionCreateRequestAction
 * @export
 */
export type ActionCreateRequestAction = CommunicationActionCreateRequest | ConditionActionCreateRequest | DelayActionCreateRequest;

/**
 * 
 * @export
 * @interface ActionDiscountCreateRequest
 */
export interface ActionDiscountCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof ActionDiscountCreateRequest
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof ActionDiscountCreateRequest
     */
    'minimumOrderValue'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActionDiscountCreateRequest
     */
    'discountType': ActionDiscountCreateRequestDiscountTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ActionDiscountCreateRequest
     */
    'expiry': number;
}

export const ActionDiscountCreateRequestDiscountTypeEnum = {
    Monetary: 'monetary',
    Percentage: 'percentage',
    FreeShipping: 'freeShipping',
    FreeSku: 'freeSku',
    Bogo: 'BOGO'
} as const;

export type ActionDiscountCreateRequestDiscountTypeEnum = typeof ActionDiscountCreateRequestDiscountTypeEnum[keyof typeof ActionDiscountCreateRequestDiscountTypeEnum];

/**
 * 
 * @export
 * @interface ActionDto
 */
export interface ActionDto {
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'flow': string;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'type': ActionDtoTypeEnum;
    /**
     * 
     * @type {ActionConnectionDto}
     * @memberof ActionDto
     */
    'connection'?: ActionConnectionDto;
    /**
     * 
     * @type {DelayDto}
     * @memberof ActionDto
     */
    'delay'?: DelayDto;
    /**
     * 
     * @type {CommunicationDto}
     * @memberof ActionDto
     */
    'communication'?: CommunicationDto;
}

export const ActionDtoTypeEnum = {
    Communication: 'communication',
    Delay: 'delay',
    Condition: 'condition',
    Discount: 'discount'
} as const;

export type ActionDtoTypeEnum = typeof ActionDtoTypeEnum[keyof typeof ActionDtoTypeEnum];

/**
 * 
 * @export
 * @interface ActionResponse
 */
export interface ActionResponse {
    /**
     * 
     * @type {ActionDto}
     * @memberof ActionResponse
     */
    'action': ActionDto;
}
/**
 * 
 * @export
 * @interface ActionsResponse
 */
export interface ActionsResponse {
    /**
     * 
     * @type {Array<ActionDto>}
     * @memberof ActionsResponse
     */
    'actions': Array<ActionDto>;
}
/**
 * 
 * @export
 * @interface AgeDistributionItem
 */
export interface AgeDistributionItem {
    /**
     * 
     * @type {number}
     * @memberof AgeDistributionItem
     */
    'age': number;
    /**
     * 
     * @type {number}
     * @memberof AgeDistributionItem
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface AggregateDto
 */
export interface AggregateDto {
    /**
     * 
     * @type {string}
     * @memberof AggregateDto
     */
    'type': AggregateDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AggregateDto
     */
    'field'?: string;
    /**
     * 
     * @type {string}
     * @memberof AggregateDto
     */
    'operation': AggregateDtoOperationEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof AggregateDto
     */
    'values': Array<number>;
}

export const AggregateDtoTypeEnum = {
    Sum: 'sum',
    Avg: 'avg',
    Count: 'count',
    Max: 'max',
    Min: 'min'
} as const;

export type AggregateDtoTypeEnum = typeof AggregateDtoTypeEnum[keyof typeof AggregateDtoTypeEnum];
export const AggregateDtoOperationEnum = {
    Equals: 'equals',
    NotEquals: 'notEquals',
    GreaterThan: 'greaterThan',
    GreaterThanOrEqual: 'greaterThanOrEqual',
    LessThan: 'lessThan',
    LessThanOrEqual: 'lessThanOrEqual',
    Between: 'between',
    In: 'in'
} as const;

export type AggregateDtoOperationEnum = typeof AggregateDtoOperationEnum[keyof typeof AggregateDtoOperationEnum];

/**
 * 
 * @export
 * @interface AppSurveyCreateRequest
 */
export interface AppSurveyCreateRequest {
    /**
     * 
     * @type {object}
     * @memberof AppSurveyCreateRequest
     */
    'name': object;
    /**
     * 
     * @type {object}
     * @memberof AppSurveyCreateRequest
     */
    'description'?: object;
    /**
     * 
     * @type {string}
     * @memberof AppSurveyCreateRequest
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSurveyCreateRequest
     */
    'status': AppSurveyCreateRequestStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AppSurveyCreateRequest
     */
    'anonymous'?: boolean;
    /**
     * 
     * @type {Array<SurveySectionsRequest>}
     * @memberof AppSurveyCreateRequest
     */
    'sections': Array<SurveySectionsRequest>;
    /**
     * 
     * @type {PointsCreateRequest}
     * @memberof AppSurveyCreateRequest
     */
    'points': PointsCreateRequest;
    /**
     * 
     * @type {object}
     * @memberof AppSurveyCreateRequest
     */
    'metadata'?: object;
}

export const AppSurveyCreateRequestStatusEnum = {
    Active: 'active',
    Inactive: 'inactive'
} as const;

export type AppSurveyCreateRequestStatusEnum = typeof AppSurveyCreateRequestStatusEnum[keyof typeof AppSurveyCreateRequestStatusEnum];

/**
 * 
 * @export
 * @interface AppSurveyDto
 */
export interface AppSurveyDto {
    /**
     * 
     * @type {string}
     * @memberof AppSurveyDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AppSurveyDto
     */
    'app': string;
    /**
     * 
     * @type {object}
     * @memberof AppSurveyDto
     */
    'name': object;
    /**
     * 
     * @type {object}
     * @memberof AppSurveyDto
     */
    'description'?: object;
    /**
     * 
     * @type {string}
     * @memberof AppSurveyDto
     */
    'image': string | null;
    /**
     * 
     * @type {string}
     * @memberof AppSurveyDto
     */
    'status': AppSurveyDtoStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AppSurveyDto
     */
    'anonymous': boolean;
    /**
     * 
     * @type {Array<SurveySectionDto>}
     * @memberof AppSurveyDto
     */
    'sections': Array<SurveySectionDto>;
    /**
     * 
     * @type {PointsDto}
     * @memberof AppSurveyDto
     */
    'points'?: PointsDto;
    /**
     * 
     * @type {object}
     * @memberof AppSurveyDto
     */
    'metadata'?: object;
    /**
     * 
     * @type {string}
     * @memberof AppSurveyDto
     */
    'createdAt': string;
}

export const AppSurveyDtoStatusEnum = {
    Active: 'active',
    Inactive: 'inactive'
} as const;

export type AppSurveyDtoStatusEnum = typeof AppSurveyDtoStatusEnum[keyof typeof AppSurveyDtoStatusEnum];

/**
 * 
 * @export
 * @interface AppSurveyResponse
 */
export interface AppSurveyResponse {
    /**
     * 
     * @type {AppSurveyDto}
     * @memberof AppSurveyResponse
     */
    'survey': AppSurveyDto;
}
/**
 * 
 * @export
 * @interface AppSurveyUpdateRequest
 */
export interface AppSurveyUpdateRequest {
    /**
     * 
     * @type {object}
     * @memberof AppSurveyUpdateRequest
     */
    'name'?: object;
    /**
     * 
     * @type {object}
     * @memberof AppSurveyUpdateRequest
     */
    'description'?: object;
    /**
     * 
     * @type {string}
     * @memberof AppSurveyUpdateRequest
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSurveyUpdateRequest
     */
    'status'?: AppSurveyUpdateRequestStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AppSurveyUpdateRequest
     */
    'anonymous'?: boolean;
    /**
     * 
     * @type {Array<SurveySectionsRequest>}
     * @memberof AppSurveyUpdateRequest
     */
    'sections'?: Array<SurveySectionsRequest>;
    /**
     * 
     * @type {PointsCreateRequest}
     * @memberof AppSurveyUpdateRequest
     */
    'points'?: PointsCreateRequest;
}

export const AppSurveyUpdateRequestStatusEnum = {
    Active: 'active',
    Inactive: 'inactive'
} as const;

export type AppSurveyUpdateRequestStatusEnum = typeof AppSurveyUpdateRequestStatusEnum[keyof typeof AppSurveyUpdateRequestStatusEnum];

/**
 * 
 * @export
 * @interface AppSurveysResponse
 */
export interface AppSurveysResponse {
    /**
     * 
     * @type {Array<AppSurveyDto>}
     * @memberof AppSurveysResponse
     */
    'surveys': Array<AppSurveyDto>;
    /**
     * 
     * @type {number}
     * @memberof AppSurveysResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface BranchConnectionCreateRequest
 */
export interface BranchConnectionCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof BranchConnectionCreateRequest
     */
    'type': BranchConnectionCreateRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BranchConnectionCreateRequest
     */
    'nextActionId': string | null;
    /**
     * 
     * @type {Array<GenericConnectionCreateRequest>}
     * @memberof BranchConnectionCreateRequest
     */
    'connections': Array<GenericConnectionCreateRequest>;
}

export const BranchConnectionCreateRequestTypeEnum = {
    Standard: 'standard',
    Branch: 'branch'
} as const;

export type BranchConnectionCreateRequestTypeEnum = typeof BranchConnectionCreateRequestTypeEnum[keyof typeof BranchConnectionCreateRequestTypeEnum];

/**
 * 
 * @export
 * @interface CartData
 */
export interface CartData {
    /**
     * 
     * @type {string}
     * @memberof CartData
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof CartData
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface ChannelDistributionItem
 */
export interface ChannelDistributionItem {
    /**
     * 
     * @type {string}
     * @memberof ChannelDistributionItem
     */
    'channel': ChannelDistributionItemChannelEnum;
    /**
     * 
     * @type {number}
     * @memberof ChannelDistributionItem
     */
    'count': number;
}

export const ChannelDistributionItemChannelEnum = {
    Email: 'email',
    Sms: 'sms',
    Whatsapp: 'whatsapp',
    Widget: 'widget'
} as const;

export type ChannelDistributionItemChannelEnum = typeof ChannelDistributionItemChannelEnum[keyof typeof ChannelDistributionItemChannelEnum];

/**
 * 
 * @export
 * @interface CommunicationActionCreateRequest
 */
export interface CommunicationActionCreateRequest {
    /**
     * 
     * @type {CommunicationActionCreateRequestConnection}
     * @memberof CommunicationActionCreateRequest
     */
    'connection': CommunicationActionCreateRequestConnection;
    /**
     * 
     * @type {string}
     * @memberof CommunicationActionCreateRequest
     */
    'type': CommunicationActionCreateRequestTypeEnum;
    /**
     * 
     * @type {CommunicationCreateRequest}
     * @memberof CommunicationActionCreateRequest
     */
    'communication': CommunicationCreateRequest;
    /**
     * 
     * @type {string}
     * @memberof CommunicationActionCreateRequest
     */
    'flow': string;
    /**
     * 
     * @type {string}
     * @memberof CommunicationActionCreateRequest
     */
    'nextActionId': string | null;
}

export const CommunicationActionCreateRequestTypeEnum = {
    Communication: 'communication',
    Delay: 'delay',
    Condition: 'condition',
    Discount: 'discount'
} as const;

export type CommunicationActionCreateRequestTypeEnum = typeof CommunicationActionCreateRequestTypeEnum[keyof typeof CommunicationActionCreateRequestTypeEnum];

/**
 * @type CommunicationActionCreateRequestConnection
 * @export
 */
export type CommunicationActionCreateRequestConnection = BranchConnectionCreateRequest | StandardConnectionCreateRequest;

/**
 * 
 * @export
 * @interface CommunicationCreateRequest
 */
export interface CommunicationCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunicationCreateRequest
     */
    'type': CommunicationCreateRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CommunicationCreateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CommunicationCreateRequest
     */
    'reciever'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunicationCreateRequest
     */
    'templateId': string;
    /**
     * 
     * @type {string}
     * @memberof CommunicationCreateRequest
     */
    'variables'?: CommunicationCreateRequestVariablesEnum;
}

export const CommunicationCreateRequestTypeEnum = {
    Email: 'email',
    Sms: 'sms',
    Whatsapp: 'whatsapp'
} as const;

export type CommunicationCreateRequestTypeEnum = typeof CommunicationCreateRequestTypeEnum[keyof typeof CommunicationCreateRequestTypeEnum];
export const CommunicationCreateRequestVariablesEnum = {
    UserEmail: 'user.email',
    UserName: 'user.name',
    UserFirstName: 'user.firstName',
    UserLastName: 'user.lastName',
    UserSource: 'user.source',
    UserGender: 'user.gender',
    UserPhone: 'user.phone',
    UserUnverifiedPhone: 'user.unverifiedPhone',
    UserExternalId: 'user.externalId',
    UserAvatar: 'user.avatar',
    UserLanguage: 'user.language',
    UserCountry: 'user.country',
    UserPristine: 'user.pristine',
    UserCpf: 'user.cpf',
    UserTier: 'user.tier',
    UserTierUpdatedDate: 'user.tierUpdatedDate',
    UserBadges: 'user.badges',
    UserPoints: 'user.points',
    UserTotals: 'user.totals',
    UserReferral: 'user.referral',
    UserType: 'user.type',
    UserSocial: 'user.social',
    UserCurrency: 'user.currency',
    UserLastLogin: 'user.lastLogin',
    UserMetadata: 'user.metadata',
    UserCreatedAt: 'user.createdAt',
    UserDateOfBirth: 'user.dateOfBirth',
    UserUserGroup: 'user.userGroup',
    UserFirstLogin: 'user.firstLogin',
    UserActive: 'user.active',
    UserEmployeeDetail: 'user.employeeDetail',
    UserCreatorSalesRepId: 'user.creatorSalesRepId',
    UserOmniChannel: 'user.omniChannel',
    UserSkipWelcomeGiftCreation: 'user.skipWelcomeGiftCreation',
    UserHasInteractedWithLs: 'user.hasInteractedWithLS',
    UserDeleted: 'user.deleted',
    UserCity: 'user.city',
    UserState: 'user.state',
    UserPostalCode: 'user.postalCode',
    UserProperties: 'user.properties',
    EnterpriseDataEmail: 'enterpriseData.email',
    EnterpriseDataPhone: 'enterpriseData.phone',
    EnterpriseDataCompanyName: 'enterpriseData.companyName',
    EnterpriseDataCompanyWebsite: 'enterpriseData.companyWebsite',
    EnterpriseDataIndustry: 'enterpriseData.industry',
    EnterpriseDataCompanySize: 'enterpriseData.companySize',
    EnterpriseDataRole: 'enterpriseData.role',
    DiscountUser: 'discount.user',
    DiscountCode: 'discount.code',
    DiscountValue: 'discount.value',
    DiscountUsed: 'discount.used',
    DiscountStatus: 'discount.status',
    DiscountReference: 'discount.reference',
    DiscountOrders: 'discount.orders',
    DiscountUsedAt: 'discount.usedAt',
    DiscountExpiresAt: 'discount.expiresAt',
    DiscountSource: 'discount.source',
    DiscountCardId: 'discount.cardId',
    DiscountTransactionId: 'discount.transactionId',
    DiscountCreatedAt: 'discount.createdAt',
    DiscountValidFrom: 'discount.validFrom',
    DiscountCreatedBy: 'discount.createdBy',
    DiscountCreatedByGroup: 'discount.createdByGroup',
    DiscountReturnedBy: 'discount.returnedBy',
    DiscountReturnedByGroup: 'discount.returnedByGroup',
    DiscountReturnedAt: 'discount.returnedAt',
    DiscountRemindsAt: 'discount.remindsAt',
    DiscountRedeemedBy: 'discount.redeemedBy',
    DiscountRedeemedByGroup: 'discount.redeemedByGroup',
    DiscountUsedValue: 'discount.usedValue',
    DiscountCashbackConfig: 'discount.cashbackConfig',
    DiscountSkuDetails: 'discount.skuDetails',
    DiscountType: 'discount.type',
    DiscountUserSource: 'discount.userSource',
    DiscountOriginalUserSource: 'discount.originalUserSource',
    DiscountRedeemedUserSource: 'discount.redeemedUserSource',
    DiscountPoints: 'discount.points',
    EventType: 'event.type',
    EventOrder: 'event.order',
    EventProduct: 'event.product',
    EventCart: 'event.cart',
    EventOrderItem: 'event.orderItem',
    EventCreatedAt: 'event.createdAt',
    EventOrderOrderId: 'event.order.orderId',
    EventOrderOrderTotal: 'event.order.orderTotal',
    EventOrderDate: 'event.order.date',
    EventOrderExternalId: 'event.order.externalId',
    EventCartCartId: 'event.cart.cartId',
    EventCartCartTotal: 'event.cart.cartTotal',
    EventProductsProductId: 'event.products.productId',
    EventProductsProductName: 'event.products.productName',
    EventProductsPrice: 'event.products.price',
    EventProductsExternalId: 'event.products.externalId',
    EventProductsCategories: 'event.products.categories',
    EventProductsGlobalCategories: 'event.products.globalCategories',
    EventProductsBrand: 'event.products.brand',
    EventProductsGlobalBrand: 'event.products.globalBrand'
} as const;

export type CommunicationCreateRequestVariablesEnum = typeof CommunicationCreateRequestVariablesEnum[keyof typeof CommunicationCreateRequestVariablesEnum];

/**
 * 
 * @export
 * @interface CommunicationDto
 */
export interface CommunicationDto {
    /**
     * 
     * @type {string}
     * @memberof CommunicationDto
     */
    'type': CommunicationDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CommunicationDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CommunicationDto
     */
    'receiver'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommunicationDto
     */
    'variables'?: Array<string>;
}

export const CommunicationDtoTypeEnum = {
    Email: 'email',
    Sms: 'sms',
    Whatsapp: 'whatsapp'
} as const;

export type CommunicationDtoTypeEnum = typeof CommunicationDtoTypeEnum[keyof typeof CommunicationDtoTypeEnum];

/**
 * 
 * @export
 * @interface ConditionActionCreateRequest
 */
export interface ConditionActionCreateRequest {
    /**
     * 
     * @type {CommunicationActionCreateRequestConnection}
     * @memberof ConditionActionCreateRequest
     */
    'connection': CommunicationActionCreateRequestConnection;
    /**
     * 
     * @type {string}
     * @memberof ConditionActionCreateRequest
     */
    'type': ConditionActionCreateRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ConditionActionCreateRequest
     */
    'flow': string;
    /**
     * 
     * @type {string}
     * @memberof ConditionActionCreateRequest
     */
    'nextActionId': string | null;
}

export const ConditionActionCreateRequestTypeEnum = {
    Communication: 'communication',
    Delay: 'delay',
    Condition: 'condition',
    Discount: 'discount'
} as const;

export type ConditionActionCreateRequestTypeEnum = typeof ConditionActionCreateRequestTypeEnum[keyof typeof ConditionActionCreateRequestTypeEnum];

/**
 * 
 * @export
 * @interface CountBySegmentResponse
 */
export interface CountBySegmentResponse {
    /**
     * 
     * @type {number}
     * @memberof CountBySegmentResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface CreateAddedToCartEvent
 */
export interface CreateAddedToCartEvent {
    /**
     * 
     * @type {string}
     * @memberof CreateAddedToCartEvent
     */
    'type': CreateAddedToCartEventTypeEnum;
    /**
     * 
     * @type {CartData}
     * @memberof CreateAddedToCartEvent
     */
    'cart': CartData;
    /**
     * 
     * @type {ProductData}
     * @memberof CreateAddedToCartEvent
     */
    'product': ProductData;
}

export const CreateAddedToCartEventTypeEnum = {
    CheckoutStarted: 'checkoutStarted',
    OrderPlaced: 'orderPlaced',
    ProductViewed: 'productViewed',
    AddedToCart: 'addedToCart',
    OrderCreated: 'orderCreated',
    OrderItemCreated: 'orderItemCreated'
} as const;

export type CreateAddedToCartEventTypeEnum = typeof CreateAddedToCartEventTypeEnum[keyof typeof CreateAddedToCartEventTypeEnum];

/**
 * 
 * @export
 * @interface CreateCheckoutStartedEvent
 */
export interface CreateCheckoutStartedEvent {
    /**
     * 
     * @type {string}
     * @memberof CreateCheckoutStartedEvent
     */
    'type': CreateCheckoutStartedEventTypeEnum;
    /**
     * 
     * @type {CartData}
     * @memberof CreateCheckoutStartedEvent
     */
    'cart': CartData;
}

export const CreateCheckoutStartedEventTypeEnum = {
    CheckoutStarted: 'checkoutStarted',
    OrderPlaced: 'orderPlaced',
    ProductViewed: 'productViewed',
    AddedToCart: 'addedToCart',
    OrderCreated: 'orderCreated',
    OrderItemCreated: 'orderItemCreated'
} as const;

export type CreateCheckoutStartedEventTypeEnum = typeof CreateCheckoutStartedEventTypeEnum[keyof typeof CreateCheckoutStartedEventTypeEnum];

/**
 * 
 * @export
 * @interface CreateEventRequest
 */
export interface CreateEventRequest {
    /**
     * 
     * @type {CreateEventRequestEvent}
     * @memberof CreateEventRequest
     */
    'event': CreateEventRequestEvent;
    /**
     * 
     * @type {string}
     * @memberof CreateEventRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEventRequest
     */
    'customerId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEventRequest
     */
    'createdAt': string;
}
/**
 * @type CreateEventRequestEvent
 * @export
 */
export type CreateEventRequestEvent = CreateAddedToCartEvent | CreateCheckoutStartedEvent | CreateOrderItemEvent | CreateOrderPlacedEvent | CreateProductViewedEvent;

/**
 * 
 * @export
 * @interface CreateFlowRequest
 */
export interface CreateFlowRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateFlowRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFlowRequest
     */
    'triggerEvent': CreateFlowRequestTriggerEventEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateFlowRequest
     */
    'status': CreateFlowRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateFlowRequest
     */
    'firstActionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFlowRequest
     */
    'triggerFilter'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateFlowRequest
     */
    'profileFilters': Array<string>;
}

export const CreateFlowRequestTriggerEventEnum = {
    CheckoutStarted: 'checkoutStarted',
    OrderPlaced: 'orderPlaced',
    ProductViewed: 'productViewed',
    AddedToCart: 'addedToCart',
    OrderCreated: 'orderCreated',
    OrderItemCreated: 'orderItemCreated'
} as const;

export type CreateFlowRequestTriggerEventEnum = typeof CreateFlowRequestTriggerEventEnum[keyof typeof CreateFlowRequestTriggerEventEnum];
export const CreateFlowRequestStatusEnum = {
    Live: 'live',
    Draft: 'draft',
    Deleted: 'deleted'
} as const;

export type CreateFlowRequestStatusEnum = typeof CreateFlowRequestStatusEnum[keyof typeof CreateFlowRequestStatusEnum];

/**
 * 
 * @export
 * @interface CreateOrderItemEvent
 */
export interface CreateOrderItemEvent {
    /**
     * 
     * @type {string}
     * @memberof CreateOrderItemEvent
     */
    'type': CreateOrderItemEventTypeEnum;
    /**
     * 
     * @type {OrderItemData}
     * @memberof CreateOrderItemEvent
     */
    'orderItem': OrderItemData;
    /**
     * 
     * @type {OrderItemOrderData}
     * @memberof CreateOrderItemEvent
     */
    'order': OrderItemOrderData;
    /**
     * 
     * @type {ProductData}
     * @memberof CreateOrderItemEvent
     */
    'product'?: ProductData;
    /**
     * 
     * @type {CartData}
     * @memberof CreateOrderItemEvent
     */
    'cart'?: CartData;
}

export const CreateOrderItemEventTypeEnum = {
    CheckoutStarted: 'checkoutStarted',
    OrderPlaced: 'orderPlaced',
    ProductViewed: 'productViewed',
    AddedToCart: 'addedToCart',
    OrderCreated: 'orderCreated',
    OrderItemCreated: 'orderItemCreated'
} as const;

export type CreateOrderItemEventTypeEnum = typeof CreateOrderItemEventTypeEnum[keyof typeof CreateOrderItemEventTypeEnum];

/**
 * 
 * @export
 * @interface CreateOrderPlacedEvent
 */
export interface CreateOrderPlacedEvent {
    /**
     * 
     * @type {string}
     * @memberof CreateOrderPlacedEvent
     */
    'type': CreateOrderPlacedEventTypeEnum;
    /**
     * 
     * @type {OrderData}
     * @memberof CreateOrderPlacedEvent
     */
    'order': OrderData;
    /**
     * 
     * @type {CartData}
     * @memberof CreateOrderPlacedEvent
     */
    'cart'?: CartData;
}

export const CreateOrderPlacedEventTypeEnum = {
    CheckoutStarted: 'checkoutStarted',
    OrderPlaced: 'orderPlaced',
    ProductViewed: 'productViewed',
    AddedToCart: 'addedToCart',
    OrderCreated: 'orderCreated',
    OrderItemCreated: 'orderItemCreated'
} as const;

export type CreateOrderPlacedEventTypeEnum = typeof CreateOrderPlacedEventTypeEnum[keyof typeof CreateOrderPlacedEventTypeEnum];

/**
 * 
 * @export
 * @interface CreateProductViewedEvent
 */
export interface CreateProductViewedEvent {
    /**
     * 
     * @type {string}
     * @memberof CreateProductViewedEvent
     */
    'type': CreateProductViewedEventTypeEnum;
    /**
     * 
     * @type {ProductData}
     * @memberof CreateProductViewedEvent
     */
    'product': ProductData;
}

export const CreateProductViewedEventTypeEnum = {
    CheckoutStarted: 'checkoutStarted',
    OrderPlaced: 'orderPlaced',
    ProductViewed: 'productViewed',
    AddedToCart: 'addedToCart',
    OrderCreated: 'orderCreated',
    OrderItemCreated: 'orderItemCreated'
} as const;

export type CreateProductViewedEventTypeEnum = typeof CreateProductViewedEventTypeEnum[keyof typeof CreateProductViewedEventTypeEnum];

/**
 * 
 * @export
 * @interface DelayActionCreateRequest
 */
export interface DelayActionCreateRequest {
    /**
     * 
     * @type {CommunicationActionCreateRequestConnection}
     * @memberof DelayActionCreateRequest
     */
    'connection': CommunicationActionCreateRequestConnection;
    /**
     * 
     * @type {string}
     * @memberof DelayActionCreateRequest
     */
    'type': DelayActionCreateRequestTypeEnum;
    /**
     * 
     * @type {DelayCreateRequest}
     * @memberof DelayActionCreateRequest
     */
    'delay': DelayCreateRequest;
    /**
     * 
     * @type {string}
     * @memberof DelayActionCreateRequest
     */
    'flow': string;
    /**
     * 
     * @type {string}
     * @memberof DelayActionCreateRequest
     */
    'nextActionId': string | null;
}

export const DelayActionCreateRequestTypeEnum = {
    Communication: 'communication',
    Delay: 'delay',
    Condition: 'condition',
    Discount: 'discount'
} as const;

export type DelayActionCreateRequestTypeEnum = typeof DelayActionCreateRequestTypeEnum[keyof typeof DelayActionCreateRequestTypeEnum];

/**
 * 
 * @export
 * @interface DelayCreateRequest
 */
export interface DelayCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof DelayCreateRequest
     */
    'minutes': number;
    /**
     * 
     * @type {number}
     * @memberof DelayCreateRequest
     */
    'hours': number;
    /**
     * 
     * @type {number}
     * @memberof DelayCreateRequest
     */
    'days': number;
}
/**
 * 
 * @export
 * @interface DelayDto
 */
export interface DelayDto {
    /**
     * 
     * @type {number}
     * @memberof DelayDto
     */
    'days'?: number;
    /**
     * 
     * @type {number}
     * @memberof DelayDto
     */
    'hours'?: number;
    /**
     * 
     * @type {number}
     * @memberof DelayDto
     */
    'minutes'?: number;
}
/**
 * 
 * @export
 * @interface DiscountActionCreateRequest
 */
export interface DiscountActionCreateRequest {
    /**
     * 
     * @type {CommunicationActionCreateRequestConnection}
     * @memberof DiscountActionCreateRequest
     */
    'connection': CommunicationActionCreateRequestConnection;
    /**
     * 
     * @type {string}
     * @memberof DiscountActionCreateRequest
     */
    'type': DiscountActionCreateRequestTypeEnum;
    /**
     * 
     * @type {ActionDiscountCreateRequest}
     * @memberof DiscountActionCreateRequest
     */
    'discount': ActionDiscountCreateRequest;
    /**
     * 
     * @type {string}
     * @memberof DiscountActionCreateRequest
     */
    'flow': string;
    /**
     * 
     * @type {string}
     * @memberof DiscountActionCreateRequest
     */
    'nextActionId': string | null;
}

export const DiscountActionCreateRequestTypeEnum = {
    Communication: 'communication',
    Delay: 'delay',
    Condition: 'condition',
    Discount: 'discount'
} as const;

export type DiscountActionCreateRequestTypeEnum = typeof DiscountActionCreateRequestTypeEnum[keyof typeof DiscountActionCreateRequestTypeEnum];

/**
 * 
 * @export
 * @interface EmployeeDetailDto
 */
export interface EmployeeDetailDto {
    /**
     * User role
     * @type {string}
     * @memberof EmployeeDetailDto
     */
    'role': string;
    /**
     * Manager ID
     * @type {string}
     * @memberof EmployeeDetailDto
     */
    'manager': string | null;
    /**
     * Organization Id
     * @type {string}
     * @memberof EmployeeDetailDto
     */
    'organization': string;
    /**
     * Department ID
     * @type {string}
     * @memberof EmployeeDetailDto
     */
    'department': string;
    /**
     * Location ID
     * @type {string}
     * @memberof EmployeeDetailDto
     */
    'location': string;
}
/**
 * 
 * @export
 * @interface FilterDto
 */
export interface FilterDto {
    /**
     * 
     * @type {string}
     * @memberof FilterDto
     */
    'type': FilterDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FilterDto
     */
    'operation': FilterDtoOperationEnum;
    /**
     * 
     * @type {object}
     * @memberof FilterDto
     */
    'value'?: object;
    /**
     * 
     * @type {object}
     * @memberof FilterDto
     */
    'start'?: object;
    /**
     * 
     * @type {object}
     * @memberof FilterDto
     */
    'end'?: object;
    /**
     * 
     * @type {string}
     * @memberof FilterDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterDto
     */
    'unit'?: FilterDtoUnitEnum;
    /**
     * 
     * @type {number}
     * @memberof FilterDto
     */
    'quantity'?: number;
}

export const FilterDtoTypeEnum = {
    String: 'string',
    Number: 'number',
    Date: 'date',
    Boolean: 'boolean'
} as const;

export type FilterDtoTypeEnum = typeof FilterDtoTypeEnum[keyof typeof FilterDtoTypeEnum];
export const FilterDtoOperationEnum = {
    Equal: '=',
    NotEqual: '!=',
    In: 'in',
    NotIn: 'notIn',
    Exists: 'exists',
    NotExists: 'notExists',
    GreaterThan: '>',
    GreaterThanOrEqualTo: '>=',
    LessThan: '<',
    LessThanOrEqualTo: '<=',
    Between: 'between',
    Contains: 'contains',
    NotContains: 'notContains',
    StartsWith: 'startsWith',
    EndsWith: 'endsWith',
    NotStartsWith: 'notStartsWith',
    NotEndsWith: 'notEndsWith',
    Regex: 'regex',
    InTheLast: 'inTheLast',
    InTheNext: 'inTheNext'
} as const;

export type FilterDtoOperationEnum = typeof FilterDtoOperationEnum[keyof typeof FilterDtoOperationEnum];
export const FilterDtoUnitEnum = {
    Weeks: 'weeks',
    Days: 'days',
    Hours: 'hours'
} as const;

export type FilterDtoUnitEnum = typeof FilterDtoUnitEnum[keyof typeof FilterDtoUnitEnum];

/**
 * 
 * @export
 * @interface FilterResponse
 */
export interface FilterResponse {
    /**
     * 
     * @type {FlowFilterDto}
     * @memberof FilterResponse
     */
    'filter': FlowFilterDto;
}
/**
 * 
 * @export
 * @interface FiltersResponse
 */
export interface FiltersResponse {
    /**
     * 
     * @type {Array<FlowFilterDto>}
     * @memberof FiltersResponse
     */
    'filters': Array<FlowFilterDto>;
}
/**
 * 
 * @export
 * @interface FirebaseCreateRequest
 */
export interface FirebaseCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof FirebaseCreateRequest
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof FirebaseCreateRequest
     */
    'domain'?: string;
    /**
     * 
     * @type {string}
     * @memberof FirebaseCreateRequest
     */
    'android'?: string;
    /**
     * 
     * @type {string}
     * @memberof FirebaseCreateRequest
     */
    'ios'?: string;
    /**
     * 
     * @type {string}
     * @memberof FirebaseCreateRequest
     */
    'link'?: string;
}
/**
 * 
 * @export
 * @interface FirebaseDto
 */
export interface FirebaseDto {
    /**
     * 
     * @type {string}
     * @memberof FirebaseDto
     */
    'domain'?: string;
    /**
     * 
     * @type {string}
     * @memberof FirebaseDto
     */
    'android'?: string;
    /**
     * 
     * @type {string}
     * @memberof FirebaseDto
     */
    'ios'?: string;
    /**
     * 
     * @type {string}
     * @memberof FirebaseDto
     */
    'link'?: string;
}
/**
 * 
 * @export
 * @interface FlowDto
 */
export interface FlowDto {
    /**
     * 
     * @type {string}
     * @memberof FlowDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDto
     */
    'firstActionId': string | null;
    /**
     * 
     * @type {string}
     * @memberof FlowDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowDto
     */
    'triggerEvent': FlowDtoTriggerEventEnum;
    /**
     * 
     * @type {string}
     * @memberof FlowDto
     */
    'status': FlowDtoStatusEnum;
}

export const FlowDtoTriggerEventEnum = {
    CheckoutStarted: 'checkoutStarted',
    OrderPlaced: 'orderPlaced',
    ProductViewed: 'productViewed',
    AddedToCart: 'addedToCart',
    OrderCreated: 'orderCreated',
    OrderItemCreated: 'orderItemCreated'
} as const;

export type FlowDtoTriggerEventEnum = typeof FlowDtoTriggerEventEnum[keyof typeof FlowDtoTriggerEventEnum];
export const FlowDtoStatusEnum = {
    Live: 'live',
    Draft: 'draft',
    Deleted: 'deleted'
} as const;

export type FlowDtoStatusEnum = typeof FlowDtoStatusEnum[keyof typeof FlowDtoStatusEnum];

/**
 * 
 * @export
 * @interface FlowFilterDto
 */
export interface FlowFilterDto {
    /**
     * 
     * @type {string}
     * @memberof FlowFilterDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowFilterDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof FlowFilterDto
     */
    'flow': string;
    /**
     * 
     * @type {string}
     * @memberof FlowFilterDto
     */
    'eventType': FlowFilterDtoEventTypeEnum;
    /**
     * 
     * @type {FilterDto}
     * @memberof FlowFilterDto
     */
    'filter': FilterDto;
    /**
     * 
     * @type {string}
     * @memberof FlowFilterDto
     */
    'type': FlowFilterDtoTypeEnum;
}

export const FlowFilterDtoEventTypeEnum = {
    CheckoutStarted: 'checkoutStarted',
    OrderPlaced: 'orderPlaced',
    ProductViewed: 'productViewed',
    AddedToCart: 'addedToCart',
    OrderCreated: 'orderCreated',
    OrderItemCreated: 'orderItemCreated'
} as const;

export type FlowFilterDtoEventTypeEnum = typeof FlowFilterDtoEventTypeEnum[keyof typeof FlowFilterDtoEventTypeEnum];
export const FlowFilterDtoTypeEnum = {
    TriggerFilter: 'triggerFilter',
    ProfileFilter: 'profileFilter'
} as const;

export type FlowFilterDtoTypeEnum = typeof FlowFilterDtoTypeEnum[keyof typeof FlowFilterDtoTypeEnum];

/**
 * 
 * @export
 * @interface FlowResponse
 */
export interface FlowResponse {
    /**
     * 
     * @type {FlowDto}
     * @memberof FlowResponse
     */
    'flow': FlowDto;
}
/**
 * 
 * @export
 * @interface GenderDistributionItem
 */
export interface GenderDistributionItem {
    /**
     * 
     * @type {string}
     * @memberof GenderDistributionItem
     */
    'gender': GenderDistributionItemGenderEnum;
    /**
     * 
     * @type {number}
     * @memberof GenderDistributionItem
     */
    'count': number;
}

export const GenderDistributionItemGenderEnum = {
    M: 'M',
    F: 'F',
    Nb: 'NB',
    I: 'I',
    J: 'J',
    N: 'N',
    NA: 'N/A',
    Empty: ''
} as const;

export type GenderDistributionItemGenderEnum = typeof GenderDistributionItemGenderEnum[keyof typeof GenderDistributionItemGenderEnum];

/**
 * 
 * @export
 * @interface GenericConnectionCreateRequest
 */
export interface GenericConnectionCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof GenericConnectionCreateRequest
     */
    'type': GenericConnectionCreateRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericConnectionCreateRequest
     */
    'nextActionId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericConnectionCreateRequest
     */
    'filter': string;
}

export const GenericConnectionCreateRequestTypeEnum = {
    Standard: 'standard',
    Branch: 'branch'
} as const;

export type GenericConnectionCreateRequestTypeEnum = typeof GenericConnectionCreateRequestTypeEnum[keyof typeof GenericConnectionCreateRequestTypeEnum];

/**
 * 
 * @export
 * @interface GenericConnectionDto
 */
export interface GenericConnectionDto {
    /**
     * 
     * @type {string}
     * @memberof GenericConnectionDto
     */
    'nextActionId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericConnectionDto
     */
    'type': GenericConnectionDtoTypeEnum;
}

export const GenericConnectionDtoTypeEnum = {
    Standard: 'standard',
    Branch: 'branch'
} as const;

export type GenericConnectionDtoTypeEnum = typeof GenericConnectionDtoTypeEnum[keyof typeof GenericConnectionDtoTypeEnum];

/**
 * 
 * @export
 * @interface GlobalCategoriesStatResponse
 */
export interface GlobalCategoriesStatResponse {
    /**
     * 
     * @type {Array<GlobalCategoryStat>}
     * @memberof GlobalCategoriesStatResponse
     */
    'globalCategories': Array<GlobalCategoryStat>;
    /**
     * 
     * @type {number}
     * @memberof GlobalCategoriesStatResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface GlobalCategoryStat
 */
export interface GlobalCategoryStat {
    /**
     * 
     * @type {number}
     * @memberof GlobalCategoryStat
     */
    'globalCategory': number;
    /**
     * 
     * @type {number}
     * @memberof GlobalCategoryStat
     */
    'audienceCount': number;
    /**
     * 
     * @type {number}
     * @memberof GlobalCategoryStat
     */
    'phoneCount': number;
    /**
     * 
     * @type {number}
     * @memberof GlobalCategoryStat
     */
    'emailCount': number;
}
/**
 * 
 * @export
 * @interface GroupDto
 */
export interface GroupDto {
    /**
     * 
     * @type {Array<RuleDto>}
     * @memberof GroupDto
     */
    'rules': Array<RuleDto>;
}
/**
 * 
 * @export
 * @interface GroupRequest
 */
export interface GroupRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof GroupRequest
     */
    'rules': Array<string>;
}
/**
 * 
 * @export
 * @interface LegacyEventResponse
 */
export interface LegacyEventResponse {
    /**
     * 
     * @type {object}
     * @memberof LegacyEventResponse
     */
    'event': object;
}
/**
 * 
 * @export
 * @interface LegacyEventsResponse
 */
export interface LegacyEventsResponse {
    /**
     * 
     * @type {Array<object>}
     * @memberof LegacyEventsResponse
     */
    'events': Array<object>;
    /**
     * 
     * @type {number}
     * @memberof LegacyEventsResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface LinkReferralDto
 */
export interface LinkReferralDto {
    /**
     * 
     * @type {string}
     * @memberof LinkReferralDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LinkReferralDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof LinkReferralDto
     */
    'referral': string;
    /**
     * 
     * @type {string}
     * @memberof LinkReferralDto
     */
    'user': string;
    /**
     * 
     * @type {string}
     * @memberof LinkReferralDto
     */
    'link': string;
    /**
     * 
     * @type {string}
     * @memberof LinkReferralDto
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface LinkReferralResponse
 */
export interface LinkReferralResponse {
    /**
     * 
     * @type {LinkReferralDto}
     * @memberof LinkReferralResponse
     */
    'linkReferral': LinkReferralDto;
}
/**
 * 
 * @export
 * @interface LocationDistributionItem
 */
export interface LocationDistributionItem {
    /**
     * 
     * @type {string}
     * @memberof LocationDistributionItem
     */
    'location': string;
    /**
     * 
     * @type {number}
     * @memberof LocationDistributionItem
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface MatchDto
 */
export interface MatchDto {
    /**
     * 
     * @type {string}
     * @memberof MatchDto
     */
    'field': string;
    /**
     * 
     * @type {string}
     * @memberof MatchDto
     */
    'operation': MatchDtoOperationEnum;
    /**
     * 
     * @type {Array<object>}
     * @memberof MatchDto
     */
    'values': Array<object>;
}

export const MatchDtoOperationEnum = {
    Equals: 'equals',
    NotEquals: 'notEquals',
    GreaterThan: 'greaterThan',
    GreaterThanOrEqual: 'greaterThanOrEqual',
    LessThan: 'lessThan',
    LessThanOrEqual: 'lessThanOrEqual',
    Between: 'between',
    In: 'in'
} as const;

export type MatchDtoOperationEnum = typeof MatchDtoOperationEnum[keyof typeof MatchDtoOperationEnum];

/**
 * 
 * @export
 * @interface MultipleChoiceQuestionCreateRequest
 */
export interface MultipleChoiceQuestionCreateRequest {
    /**
     * 
     * @type {object}
     * @memberof MultipleChoiceQuestionCreateRequest
     */
    'text': object;
    /**
     * 
     * @type {string}
     * @memberof MultipleChoiceQuestionCreateRequest
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof MultipleChoiceQuestionCreateRequest
     */
    'background'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MultipleChoiceQuestionCreateRequest
     */
    'isTextHidden': boolean;
}
/**
 * 
 * @export
 * @interface MultipleChoiceQuestionDto
 */
export interface MultipleChoiceQuestionDto {
    /**
     * 
     * @type {object}
     * @memberof MultipleChoiceQuestionDto
     */
    'text': object;
    /**
     * 
     * @type {string}
     * @memberof MultipleChoiceQuestionDto
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof MultipleChoiceQuestionDto
     */
    'background'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MultipleChoiceQuestionDto
     */
    'isTextHidden': boolean;
}
/**
 * 
 * @export
 * @interface NonRestrictedEventCreateRequest
 */
export interface NonRestrictedEventCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof NonRestrictedEventCreateRequest
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof NonRestrictedEventCreateRequest
     */
    'type': string;
    /**
     * 
     * @type {object}
     * @memberof NonRestrictedEventCreateRequest
     */
    'metadata'?: object;
}
/**
 * 
 * @export
 * @interface OrderData
 */
export interface OrderData {
    /**
     * 
     * @type {string}
     * @memberof OrderData
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderData
     */
    'total': number;
    /**
     * 
     * @type {string}
     * @memberof OrderData
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof OrderData
     */
    'externalId': string;
}
/**
 * 
 * @export
 * @interface OrderItemData
 */
export interface OrderItemData {
    /**
     * 
     * @type {string}
     * @memberof OrderItemData
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemData
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemData
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemData
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemData
     */
    'externalId': string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemData
     */
    'externalProductId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemData
     */
    'externalSkuId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemData
     */
    'productId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderItemData
     */
    'categories'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OrderItemData
     */
    'brand'?: string;
}
/**
 * 
 * @export
 * @interface OrderItemOrderData
 */
export interface OrderItemOrderData {
    /**
     * 
     * @type {string}
     * @memberof OrderItemOrderData
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemOrderData
     */
    'total': number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemOrderData
     */
    'externalId': string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemOrderData
     */
    'date': string;
}
/**
 * 
 * @export
 * @interface PointsCreateRequest
 */
export interface PointsCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof PointsCreateRequest
     */
    'gems': number;
    /**
     * 
     * @type {number}
     * @memberof PointsCreateRequest
     */
    'exp': number;
}
/**
 * 
 * @export
 * @interface PointsDto
 */
export interface PointsDto {
    /**
     * 
     * @type {number}
     * @memberof PointsDto
     */
    'gems': number;
    /**
     * 
     * @type {number}
     * @memberof PointsDto
     */
    'exp': number;
}
/**
 * 
 * @export
 * @interface PointsUpdateRequest
 */
export interface PointsUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof PointsUpdateRequest
     */
    'gems'?: number;
    /**
     * 
     * @type {number}
     * @memberof PointsUpdateRequest
     */
    'exp'?: number;
}
/**
 * 
 * @export
 * @interface ProductData
 */
export interface ProductData {
    /**
     * 
     * @type {string}
     * @memberof ProductData
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductData
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductData
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof ProductData
     */
    'externalId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductData
     */
    'categories': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductData
     */
    'globalCategories': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProductData
     */
    'brand'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductData
     */
    'globalBrand'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductData
     */
    'globalProduct': string;
}
/**
 * 
 * @export
 * @interface QuestionRulesDto
 */
export interface QuestionRulesDto {
    /**
     * 
     * @type {boolean}
     * @memberof QuestionRulesDto
     */
    'required'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QuestionRulesDto
     */
    'pattern'?: string;
}
/**
 * 
 * @export
 * @interface QuestionRulesRequest
 */
export interface QuestionRulesRequest {
    /**
     * 
     * @type {boolean}
     * @memberof QuestionRulesRequest
     */
    'required'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QuestionRulesRequest
     */
    'pattern'?: string;
}
/**
 * 
 * @export
 * @interface QuestionsCreateRequest
 */
export interface QuestionsCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsCreateRequest
     */
    'id'?: string;
    /**
     * 
     * @type {object}
     * @memberof QuestionsCreateRequest
     */
    'text': object;
    /**
     * 
     * @type {string}
     * @memberof QuestionsCreateRequest
     */
    'type': QuestionsCreateRequestTypeEnum;
    /**
     * 
     * @type {Array<MultipleChoiceQuestionCreateRequest>}
     * @memberof QuestionsCreateRequest
     */
    'options'?: Array<MultipleChoiceQuestionCreateRequest>;
    /**
     * 
     * @type {QuestionRulesRequest}
     * @memberof QuestionsCreateRequest
     */
    'rules'?: QuestionRulesRequest;
    /**
     * 
     * @type {string}
     * @memberof QuestionsCreateRequest
     */
    'placeholder'?: string;
    /**
     * 
     * @type {object}
     * @memberof QuestionsCreateRequest
     */
    'metadata'?: object;
    /**
     * 
     * @type {string}
     * @memberof QuestionsCreateRequest
     */
    'image'?: string;
}

export const QuestionsCreateRequestTypeEnum = {
    SingleSelect: 'singleSelect',
    DatePicker: 'datePicker',
    Text: 'text',
    LikeDislike: 'likeDislike',
    OpenEnded: 'openEnded',
    MultiSelect: 'multiSelect'
} as const;

export type QuestionsCreateRequestTypeEnum = typeof QuestionsCreateRequestTypeEnum[keyof typeof QuestionsCreateRequestTypeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const ReferralCreateEnabledSharingOptions = {
    Whatsapp: 'whatsapp',
    Email: 'email',
    CopyLink: 'copyLink'
} as const;

export type ReferralCreateEnabledSharingOptions = typeof ReferralCreateEnabledSharingOptions[keyof typeof ReferralCreateEnabledSharingOptions];


/**
 * 
 * @export
 * @interface ReferralCreateRequest
 */
export interface ReferralCreateRequest {
    /**
     * 
     * @type {Array<ReferralCreateEnabledSharingOptions>}
     * @memberof ReferralCreateRequest
     */
    'enabledSharingOptions': Array<ReferralCreateEnabledSharingOptions>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReferralCreateRequest
     */
    'events': Array<string>;
    /**
     * 
     * @type {ReferralPointsCreateRequest}
     * @memberof ReferralCreateRequest
     */
    'referrerPoints'?: ReferralPointsCreateRequest;
    /**
     * 
     * @type {ReferralPointsCreateRequest}
     * @memberof ReferralCreateRequest
     */
    'refereePoints'?: ReferralPointsCreateRequest;
    /**
     * 
     * @type {FirebaseCreateRequest}
     * @memberof ReferralCreateRequest
     */
    'firebase'?: FirebaseCreateRequest;
    /**
     * 
     * @type {string}
     * @memberof ReferralCreateRequest
     */
    'domain'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralCreateRequest
     */
    'subdomain'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReferralCreateRequest
     */
    'isEmailSuppressed'?: boolean;
}
/**
 * 
 * @export
 * @interface ReferralDto
 */
export interface ReferralDto {
    /**
     * 
     * @type {string}
     * @memberof ReferralDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ReferralDto
     */
    'app': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReferralDto
     */
    'events': Array<string>;
    /**
     * 
     * @type {ReferralPointsDto}
     * @memberof ReferralDto
     */
    'referrerPoints'?: ReferralPointsDto;
    /**
     * 
     * @type {ReferralPointsDto}
     * @memberof ReferralDto
     */
    'refereePoints'?: ReferralPointsDto;
    /**
     * 
     * @type {FirebaseDto}
     * @memberof ReferralDto
     */
    'firebase'?: FirebaseDto;
    /**
     * 
     * @type {string}
     * @memberof ReferralDto
     */
    'domain': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReferralDto
     */
    'enabled': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReferralDto
     */
    'enabledSharingOptions': Array<ReferralDtoEnabledSharingOptionsEnum>;
    /**
     * 
     * @type {string}
     * @memberof ReferralDto
     */
    'createdAt': string;
}

export const ReferralDtoEnabledSharingOptionsEnum = {
    Whatsapp: 'whatsapp',
    Email: 'email',
    CopyLink: 'copyLink'
} as const;

export type ReferralDtoEnabledSharingOptionsEnum = typeof ReferralDtoEnabledSharingOptionsEnum[keyof typeof ReferralDtoEnabledSharingOptionsEnum];

/**
 * 
 * @export
 * @interface ReferralPointsCreateRequest
 */
export interface ReferralPointsCreateRequest {
    /**
     * 
     * @type {PointsCreateRequest}
     * @memberof ReferralPointsCreateRequest
     */
    'invite': PointsCreateRequest;
    /**
     * 
     * @type {PointsCreateRequest}
     * @memberof ReferralPointsCreateRequest
     */
    'purchase': PointsCreateRequest;
}
/**
 * 
 * @export
 * @interface ReferralPointsDto
 */
export interface ReferralPointsDto {
    /**
     * 
     * @type {PointsDto}
     * @memberof ReferralPointsDto
     */
    'invite': PointsDto;
    /**
     * 
     * @type {PointsDto}
     * @memberof ReferralPointsDto
     */
    'purchase': PointsDto;
}
/**
 * 
 * @export
 * @interface ReferralPointsUpdateRequest
 */
export interface ReferralPointsUpdateRequest {
    /**
     * 
     * @type {PointsUpdateRequest}
     * @memberof ReferralPointsUpdateRequest
     */
    'invite'?: PointsUpdateRequest;
    /**
     * 
     * @type {PointsUpdateRequest}
     * @memberof ReferralPointsUpdateRequest
     */
    'purchase'?: PointsUpdateRequest;
}
/**
 * 
 * @export
 * @interface ReferralResponse
 */
export interface ReferralResponse {
    /**
     * 
     * @type {ReferralDto}
     * @memberof ReferralResponse
     */
    'referral': ReferralDto;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ReferralUpdateEnabledSharingOptions = {
    Whatsapp: 'whatsapp',
    Email: 'email',
    CopyLink: 'copyLink'
} as const;

export type ReferralUpdateEnabledSharingOptions = typeof ReferralUpdateEnabledSharingOptions[keyof typeof ReferralUpdateEnabledSharingOptions];


/**
 * 
 * @export
 * @interface ReferralUpdateRequest
 */
export interface ReferralUpdateRequest {
    /**
     * 
     * @type {Array<ReferralUpdateEnabledSharingOptions>}
     * @memberof ReferralUpdateRequest
     */
    'enabledSharingOptions'?: Array<ReferralUpdateEnabledSharingOptions>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReferralUpdateRequest
     */
    'events'?: Array<string>;
    /**
     * 
     * @type {ReferralPointsUpdateRequest}
     * @memberof ReferralUpdateRequest
     */
    'referrerPoints'?: ReferralPointsUpdateRequest;
    /**
     * 
     * @type {ReferralPointsUpdateRequest}
     * @memberof ReferralUpdateRequest
     */
    'refereePoints'?: ReferralPointsUpdateRequest;
    /**
     * 
     * @type {FirebaseCreateRequest}
     * @memberof ReferralUpdateRequest
     */
    'firebase'?: FirebaseCreateRequest;
    /**
     * 
     * @type {string}
     * @memberof ReferralUpdateRequest
     */
    'domain'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReferralUpdateRequest
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReferralUpdateRequest
     */
    'subdomain'?: string;
}
/**
 * 
 * @export
 * @interface ReferralsResponse
 */
export interface ReferralsResponse {
    /**
     * 
     * @type {Array<ReferralDto>}
     * @memberof ReferralsResponse
     */
    'referrals': Array<ReferralDto>;
    /**
     * 
     * @type {number}
     * @memberof ReferralsResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface RestrictedEventCreateRequest
 */
export interface RestrictedEventCreateRequest {
    /**
     * 
     * @type {UserEventRequest}
     * @memberof RestrictedEventCreateRequest
     */
    'user': UserEventRequest;
    /**
     * 
     * @type {string}
     * @memberof RestrictedEventCreateRequest
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof RestrictedEventCreateRequest
     */
    'type': string;
    /**
     * 
     * @type {object}
     * @memberof RestrictedEventCreateRequest
     */
    'metadata'?: object;
}
/**
 * 
 * @export
 * @interface RfmDistributionItem
 */
export interface RfmDistributionItem {
    /**
     * 
     * @type {string}
     * @memberof RfmDistributionItem
     */
    'rfmGroup': RfmDistributionItemRfmGroupEnum;
    /**
     * 
     * @type {number}
     * @memberof RfmDistributionItem
     */
    'count': number;
}

export const RfmDistributionItemRfmGroupEnum = {
    TopBuyer: 'top_buyer',
    ActiveBuyer: 'active_buyer',
    FrequentBuyer: 'frequent_buyer',
    HighValueBuyer: 'high_value_buyer',
    RecentBuyer: 'recent_buyer',
    GeneralBuyer: 'general_buyer'
} as const;

export type RfmDistributionItemRfmGroupEnum = typeof RfmDistributionItemRfmGroupEnum[keyof typeof RfmDistributionItemRfmGroupEnum];

/**
 * 
 * @export
 * @interface RuleDto
 */
export interface RuleDto {
    /**
     * 
     * @type {string}
     * @memberof RuleDto
     */
    'type': RuleDtoTypeEnum;
    /**
     * 
     * @type {Array<MatchDto>}
     * @memberof RuleDto
     */
    'matches': Array<MatchDto>;
    /**
     * 
     * @type {AggregateDto}
     * @memberof RuleDto
     */
    'aggregate'?: AggregateDto;
}

export const RuleDtoTypeEnum = {
    User: 'user',
    OrderEvent: 'orderEvent',
    CartEvent: 'cartEvent',
    ProductEvent: 'productEvent',
    OrderItemEvent: 'orderItemEvent'
} as const;

export type RuleDtoTypeEnum = typeof RuleDtoTypeEnum[keyof typeof RuleDtoTypeEnum];

/**
 * 
 * @export
 * @interface SegmentDto
 */
export interface SegmentDto {
    /**
     * 
     * @type {string}
     * @memberof SegmentDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SegmentDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof SegmentDto
     */
    'description': string;
    /**
     * 
     * @type {Array<GroupDto>}
     * @memberof SegmentDto
     */
    'groups': Array<GroupDto>;
    /**
     * 
     * @type {string}
     * @memberof SegmentDto
     */
    'status': SegmentDtoStatusEnum;
}

export const SegmentDtoStatusEnum = {
    Active: 'active',
    Draft: 'draft',
    Deleted: 'deleted'
} as const;

export type SegmentDtoStatusEnum = typeof SegmentDtoStatusEnum[keyof typeof SegmentDtoStatusEnum];

/**
 * 
 * @export
 * @interface SegmentRequest
 */
export interface SegmentRequest {
    /**
     * 
     * @type {string}
     * @memberof SegmentRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SegmentRequest
     */
    'description': string;
    /**
     * 
     * @type {Array<GroupRequest>}
     * @memberof SegmentRequest
     */
    'groups': Array<GroupRequest>;
    /**
     * 
     * @type {string}
     * @memberof SegmentRequest
     */
    'status': SegmentRequestStatusEnum;
}

export const SegmentRequestStatusEnum = {
    Active: 'active',
    Draft: 'draft',
    Deleted: 'deleted'
} as const;

export type SegmentRequestStatusEnum = typeof SegmentRequestStatusEnum[keyof typeof SegmentRequestStatusEnum];

/**
 * 
 * @export
 * @interface SegmentResponse
 */
export interface SegmentResponse {
    /**
     * 
     * @type {SegmentDto}
     * @memberof SegmentResponse
     */
    'segment': SegmentDto;
}
/**
 * 
 * @export
 * @interface SegmentUserDto
 */
export interface SegmentUserDto {
    /**
     * 
     * @type {string}
     * @memberof SegmentUserDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof SegmentUserDto
     */
    'segment': string;
    /**
     * 
     * @type {string}
     * @memberof SegmentUserDto
     */
    'user': string;
}
/**
 * 
 * @export
 * @interface SegmentUsersResponse
 */
export interface SegmentUsersResponse {
    /**
     * 
     * @type {Array<SegmentUserDto>}
     * @memberof SegmentUsersResponse
     */
    'segmentUsers': Array<SegmentUserDto>;
    /**
     * 
     * @type {string}
     * @memberof SegmentUsersResponse
     */
    'nextPageToken'?: string;
}
/**
 * 
 * @export
 * @interface SegmentsResponse
 */
export interface SegmentsResponse {
    /**
     * 
     * @type {Array<SegmentDto>}
     * @memberof SegmentsResponse
     */
    'segments': Array<SegmentDto>;
    /**
     * 
     * @type {number}
     * @memberof SegmentsResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface SimpleDateDto
 */
export interface SimpleDateDto {
    /**
     * Year
     * @type {number}
     * @memberof SimpleDateDto
     */
    'year': number;
    /**
     * Month
     * @type {number}
     * @memberof SimpleDateDto
     */
    'month': number;
    /**
     * Day
     * @type {number}
     * @memberof SimpleDateDto
     */
    'day': number;
}
/**
 * 
 * @export
 * @interface StandardConnectionCreateRequest
 */
export interface StandardConnectionCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof StandardConnectionCreateRequest
     */
    'type': StandardConnectionCreateRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof StandardConnectionCreateRequest
     */
    'nextActionId': string | null;
}

export const StandardConnectionCreateRequestTypeEnum = {
    Standard: 'standard',
    Branch: 'branch'
} as const;

export type StandardConnectionCreateRequestTypeEnum = typeof StandardConnectionCreateRequestTypeEnum[keyof typeof StandardConnectionCreateRequestTypeEnum];

/**
 * 
 * @export
 * @interface SurveyQuestionDto
 */
export interface SurveyQuestionDto {
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionDto
     */
    'image'?: string;
    /**
     * 
     * @type {object}
     * @memberof SurveyQuestionDto
     */
    'text': object;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionDto
     */
    'type': SurveyQuestionDtoTypeEnum;
    /**
     * 
     * @type {Array<MultipleChoiceQuestionDto>}
     * @memberof SurveyQuestionDto
     */
    'options'?: Array<MultipleChoiceQuestionDto>;
    /**
     * 
     * @type {QuestionRulesDto}
     * @memberof SurveyQuestionDto
     */
    'rules'?: QuestionRulesDto;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionDto
     */
    'placeholder'?: string;
    /**
     * 
     * @type {object}
     * @memberof SurveyQuestionDto
     */
    'metadata'?: object;
}

export const SurveyQuestionDtoTypeEnum = {
    SingleSelect: 'singleSelect',
    DatePicker: 'datePicker',
    Text: 'text',
    LikeDislike: 'likeDislike',
    OpenEnded: 'openEnded',
    MultiSelect: 'multiSelect'
} as const;

export type SurveyQuestionDtoTypeEnum = typeof SurveyQuestionDtoTypeEnum[keyof typeof SurveyQuestionDtoTypeEnum];

/**
 * 
 * @export
 * @interface SurveySectionDto
 */
export interface SurveySectionDto {
    /**
     * 
     * @type {object}
     * @memberof SurveySectionDto
     */
    'title'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof SurveySectionDto
     */
    'required': boolean;
    /**
     * 
     * @type {Array<SurveyQuestionDto>}
     * @memberof SurveySectionDto
     */
    'questions': Array<SurveyQuestionDto>;
}
/**
 * 
 * @export
 * @interface SurveySectionsRequest
 */
export interface SurveySectionsRequest {
    /**
     * 
     * @type {object}
     * @memberof SurveySectionsRequest
     */
    'title'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof SurveySectionsRequest
     */
    'required': boolean;
    /**
     * 
     * @type {Array<QuestionsCreateRequest>}
     * @memberof SurveySectionsRequest
     */
    'questions': Array<QuestionsCreateRequest>;
}
/**
 * 
 * @export
 * @interface TotalsDto
 */
export interface TotalsDto {
    /**
     * Total number of completed missions
     * @type {number}
     * @memberof TotalsDto
     */
    'numberOfCompletedMissions': number;
    /**
     * Total number of active points
     * @type {number}
     * @memberof TotalsDto
     */
    'totalActivePoints': number;
    /**
     * Total number of cashback balance
     * @type {number}
     * @memberof TotalsDto
     */
    'totalCashbackBalance': number;
    /**
     * Total number of recent cashback earned
     * @type {number}
     * @memberof TotalsDto
     */
    'recentCashbackEarned': number;
    /**
     * Total number of redeemed points
     * @type {number}
     * @memberof TotalsDto
     */
    'totalRedeemedPoints': number;
    /**
     * Total number of generated points
     * @type {number}
     * @memberof TotalsDto
     */
    'totalGeneratedPoints': number;
    /**
     * Total number of campaign disocunts
     * @type {number}
     * @memberof TotalsDto
     */
    'numberOfCreatedCampaignDiscounts': number;
    /**
     * Total number of used campaign discounts
     * @type {number}
     * @memberof TotalsDto
     */
    'numberOfUsedCampaignDiscounts': number;
    /**
     * Total number of orders
     * @type {number}
     * @memberof TotalsDto
     */
    'ordersCount': number;
    /**
     * Total sum of orders values
     * @type {number}
     * @memberof TotalsDto
     */
    'ordersTotal': number;
    /**
     * Total number of online orders
     * @type {number}
     * @memberof TotalsDto
     */
    'onlineOrdersCount': number;
    /**
     * Total sum of online orders values
     * @type {number}
     * @memberof TotalsDto
     */
    'onlineOrdersTotal': number;
    /**
     * Total number of offline orders
     * @type {number}
     * @memberof TotalsDto
     */
    'offlineOrdersCount': number;
    /**
     * Total sum of offline orders values
     * @type {number}
     * @memberof TotalsDto
     */
    'offlineOrdersTotal': number;
}
/**
 * 
 * @export
 * @interface UpdateFlowRequest
 */
export interface UpdateFlowRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateFlowRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFlowRequest
     */
    'triggerEvent'?: UpdateFlowRequestTriggerEventEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateFlowRequest
     */
    'status'?: UpdateFlowRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateFlowRequest
     */
    'firstActionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFlowRequest
     */
    'triggerFilter'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateFlowRequest
     */
    'profileFilters': Array<string>;
}

export const UpdateFlowRequestTriggerEventEnum = {
    CheckoutStarted: 'checkoutStarted',
    OrderPlaced: 'orderPlaced',
    ProductViewed: 'productViewed',
    AddedToCart: 'addedToCart',
    OrderCreated: 'orderCreated',
    OrderItemCreated: 'orderItemCreated'
} as const;

export type UpdateFlowRequestTriggerEventEnum = typeof UpdateFlowRequestTriggerEventEnum[keyof typeof UpdateFlowRequestTriggerEventEnum];
export const UpdateFlowRequestStatusEnum = {
    Live: 'live',
    Draft: 'draft',
    Deleted: 'deleted'
} as const;

export type UpdateFlowRequestStatusEnum = typeof UpdateFlowRequestStatusEnum[keyof typeof UpdateFlowRequestStatusEnum];

/**
 * 
 * @export
 * @interface UpdateSegmentRequest
 */
export interface UpdateSegmentRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateSegmentRequest
     */
    'status': UpdateSegmentRequestStatusEnum;
}

export const UpdateSegmentRequestStatusEnum = {
    Active: 'active',
    Draft: 'draft',
    Deleted: 'deleted'
} as const;

export type UpdateSegmentRequestStatusEnum = typeof UpdateSegmentRequestStatusEnum[keyof typeof UpdateSegmentRequestStatusEnum];

/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * User unique identifier
     * @type {string}
     * @memberof UserDto
     */
    'id': string;
    /**
     * App id
     * @type {string}
     * @memberof UserDto
     */
    'app': string;
    /**
     * User email
     * @type {string}
     * @memberof UserDto
     */
    'email'?: string | null;
    /**
     * User name
     * @type {string}
     * @memberof UserDto
     */
    'name': string | null;
    /**
     * User first name
     * @type {string}
     * @memberof UserDto
     */
    'firstName': string | null;
    /**
     * User last name
     * @type {string}
     * @memberof UserDto
     */
    'lastName': string | null;
    /**
     * User creation source
     * @type {string}
     * @memberof UserDto
     */
    'source'?: UserDtoSourceEnum;
    /**
     * User gender
     * @type {object}
     * @memberof UserDto
     */
    'gender': UserDtoGenderEnum | null;
    /**
     * User phone number
     * @type {string}
     * @memberof UserDto
     */
    'phone'?: string;
    /**
     * User Unverified phone number
     * @type {string}
     * @memberof UserDto
     */
    'unverifiedPhone'?: string;
    /**
     * User external identifier
     * @type {string}
     * @memberof UserDto
     */
    'externalId': string | null;
    /**
     * Avatar
     * @type {string}
     * @memberof UserDto
     */
    'avatar': string | null;
    /**
     * User language
     * @type {string}
     * @memberof UserDto
     */
    'language': UserDtoLanguageEnum;
    /**
     * User country
     * @type {string}
     * @memberof UserDto
     */
    'country': string;
    /**
     * Pristine
     * @type {boolean}
     * @memberof UserDto
     */
    'pristine': boolean;
    /**
     * User CPF
     * @type {string}
     * @memberof UserDto
     */
    'cpf'?: string;
    /**
     * User current level
     * @type {number}
     * @memberof UserDto
     */
    'tier': number;
    /**
     * Date of last user level update
     * @type {string}
     * @memberof UserDto
     */
    'tierUpdatedDate': string | null;
    /**
     * User Badges
     * @type {Array<string>}
     * @memberof UserDto
     */
    'badges': Array<string>;
    /**
     * current user poitns
     * @type {UserPointsDto}
     * @memberof UserDto
     */
    'points': UserPointsDto;
    /**
     * User statitics
     * @type {TotalsDto}
     * @memberof UserDto
     */
    'totals': TotalsDto;
    /**
     * User referral status
     * @type {UserReferralsDto}
     * @memberof UserDto
     */
    'referral': UserReferralsDto;
    /**
     * User type, eg member, draft, prospect
     * @type {string}
     * @memberof UserDto
     */
    'type': UserDtoTypeEnum;
    /**
     * User Socials links
     * @type {UserSocialDto}
     * @memberof UserDto
     */
    'social': UserSocialDto;
    /**
     * User Currency
     * @type {string}
     * @memberof UserDto
     */
    'currency': string;
    /**
     * User last logn date
     * @type {string}
     * @memberof UserDto
     */
    'lastLogin': string | null;
    /**
     * Metadata
     * @type {object}
     * @memberof UserDto
     */
    'metadata': object | null;
    /**
     * User creation date
     * @type {string}
     * @memberof UserDto
     */
    'createdAt': string;
    /**
     * 
     * @type {UserDtoDateOfBirth}
     * @memberof UserDto
     */
    'dateOfBirth': UserDtoDateOfBirth | null;
    /**
     * User group id
     * @type {string}
     * @memberof UserDto
     */
    'userGroup': string | null;
    /**
     * User first login date
     * @type {boolean}
     * @memberof UserDto
     */
    'firstLogin': boolean | null;
    /**
     * User active status
     * @type {boolean}
     * @memberof UserDto
     */
    'active': boolean;
    /**
     * 
     * @type {UserDtoEmployeeDetail}
     * @memberof UserDto
     */
    'employeeDetail': UserDtoEmployeeDetail | null;
    /**
     * Identifier of the sales rep that created the user
     * @type {string}
     * @memberof UserDto
     */
    'creatorSalesRepId'?: string;
    /**
     * Indicates if users engage in transactions through both online and offline platforms
     * @type {boolean}
     * @memberof UserDto
     */
    'omniChannel': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    'skipWelcomeGiftCreation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    'hasInteractedWithLS': boolean;
    /**
     * User Properties
     * @type {UserPropertiesDTO}
     * @memberof UserDto
     */
    'properties': UserPropertiesDTO;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'postalCode'?: string;
}

export const UserDtoSourceEnum = {
    Online: 'online',
    Offline: 'offline'
} as const;

export type UserDtoSourceEnum = typeof UserDtoSourceEnum[keyof typeof UserDtoSourceEnum];
export const UserDtoGenderEnum = {
    M: 'M',
    F: 'F',
    Nb: 'NB',
    I: 'I',
    J: 'J',
    N: 'N',
    NA: 'N/A',
    Empty: ''
} as const;

export type UserDtoGenderEnum = typeof UserDtoGenderEnum[keyof typeof UserDtoGenderEnum];
export const UserDtoLanguageEnum = {
    En: 'en',
    Es: 'es',
    Pt: 'pt',
    Ar: 'ar'
} as const;

export type UserDtoLanguageEnum = typeof UserDtoLanguageEnum[keyof typeof UserDtoLanguageEnum];
export const UserDtoTypeEnum = {
    Draft: 'draft',
    Member: 'member',
    Prospect: 'prospect',
    Registered: 'registered'
} as const;

export type UserDtoTypeEnum = typeof UserDtoTypeEnum[keyof typeof UserDtoTypeEnum];

/**
 * User birthday
 * @export
 * @interface UserDtoDateOfBirth
 */
export interface UserDtoDateOfBirth {
    /**
     * Year
     * @type {number}
     * @memberof UserDtoDateOfBirth
     */
    'year': number;
    /**
     * Month
     * @type {number}
     * @memberof UserDtoDateOfBirth
     */
    'month': number;
    /**
     * Day
     * @type {number}
     * @memberof UserDtoDateOfBirth
     */
    'day': number;
}
/**
 * User Employee details
 * @export
 * @interface UserDtoEmployeeDetail
 */
export interface UserDtoEmployeeDetail {
    /**
     * User role
     * @type {string}
     * @memberof UserDtoEmployeeDetail
     */
    'role': string;
    /**
     * Manager ID
     * @type {string}
     * @memberof UserDtoEmployeeDetail
     */
    'manager': string | null;
    /**
     * Organization Id
     * @type {string}
     * @memberof UserDtoEmployeeDetail
     */
    'organization': string;
    /**
     * Department ID
     * @type {string}
     * @memberof UserDtoEmployeeDetail
     */
    'department': string;
    /**
     * Location ID
     * @type {string}
     * @memberof UserDtoEmployeeDetail
     */
    'location': string;
}
/**
 * 
 * @export
 * @interface UserEventRequest
 */
export interface UserEventRequest {
    /**
     * 
     * @type {string}
     * @memberof UserEventRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEventRequest
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface UserPointsDto
 */
export interface UserPointsDto {
    /**
     * Points
     * @type {number}
     * @memberof UserPointsDto
     */
    'gems': number;
    /**
     * Level points
     * @type {number}
     * @memberof UserPointsDto
     */
    'exp': number;
}
/**
 * 
 * @export
 * @interface UserPropertiesDTO
 */
export interface UserPropertiesDTO {
    /**
     * Last purchase date
     * @type {string}
     * @memberof UserPropertiesDTO
     */
    'lastPurchaseDate': string | null;
    /**
     * Average time between purchases
     * @type {number}
     * @memberof UserPropertiesDTO
     */
    'averageBetweenPurchases': number;
    /**
     * Discount usage rate
     * @type {number}
     * @memberof UserPropertiesDTO
     */
    'discountUsageRate': number;
    /**
     * Count of completed purchases
     * @type {number}
     * @memberof UserPropertiesDTO
     */
    'completedPurchasesCount': number;
    /**
     * Count of internal discounts used
     * @type {number}
     * @memberof UserPropertiesDTO
     */
    'internalUsedDiscounts': number;
    /**
     * Last interactive date
     * @type {string}
     * @memberof UserPropertiesDTO
     */
    'lastInteractiveDate': string | null;
    /**
     * Communication Statistics
     * @type {object}
     * @memberof UserPropertiesDTO
     */
    'communication'?: object;
}
/**
 * 
 * @export
 * @interface UserReferralDto
 */
export interface UserReferralDto {
    /**
     * 
     * @type {string}
     * @memberof UserReferralDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserReferralDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof UserReferralDto
     */
    'user': string;
    /**
     * 
     * @type {string}
     * @memberof UserReferralDto
     */
    'referee': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserReferralDto
     */
    'referral': string;
    /**
     * 
     * @type {string}
     * @memberof UserReferralDto
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof UserReferralDto
     */
    'joinedAt': string | null;
    /**
     * 
     * @type {object}
     * @memberof UserReferralDto
     */
    'metadata': object | null;
    /**
     * 
     * @type {string}
     * @memberof UserReferralDto
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface UserReferralInvitation
 */
export interface UserReferralInvitation {
    /**
     * 
     * @type {string}
     * @memberof UserReferralInvitation
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UserReferralInvitation
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserReferralInvitation
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserReferralInvitation
     */
    'sourceId'?: string;
}
/**
 * 
 * @export
 * @interface UserReferralResponse
 */
export interface UserReferralResponse {
    /**
     * 
     * @type {UserReferralDto}
     * @memberof UserReferralResponse
     */
    'userReferral': UserReferralDto;
}
/**
 * 
 * @export
 * @interface UserReferralsDto
 */
export interface UserReferralsDto {
    /**
     * Referrer ID
     * @type {string}
     * @memberof UserReferralsDto
     */
    'referrer': string | null;
    /**
     * Referral source
     * @type {object}
     * @memberof UserReferralsDto
     */
    'source': UserReferralsDtoSourceEnum | null;
}

export const UserReferralsDtoSourceEnum = {
    OfflineOrder: 'offlineOrder',
    OnlineOrder: 'onlineOrder'
} as const;

export type UserReferralsDtoSourceEnum = typeof UserReferralsDtoSourceEnum[keyof typeof UserReferralsDtoSourceEnum];

/**
 * 
 * @export
 * @interface UserReferralsResponse
 */
export interface UserReferralsResponse {
    /**
     * 
     * @type {Array<UserReferralDto>}
     * @memberof UserReferralsResponse
     */
    'userReferrals': Array<UserReferralDto>;
    /**
     * 
     * @type {number}
     * @memberof UserReferralsResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface UserSocialDto
 */
export interface UserSocialDto {
    /**
     * Facebook link
     * @type {string}
     * @memberof UserSocialDto
     */
    'facebook': string | null;
    /**
     * Instagram link
     * @type {string}
     * @memberof UserSocialDto
     */
    'instagram': string | null;
}
/**
 * 
 * @export
 * @interface UserSurveyAnswerCreateRequest
 */
export interface UserSurveyAnswerCreateRequest {
    /**
     * 
     * @type {UserSurveyAnswerUpdateRequestAnswer}
     * @memberof UserSurveyAnswerCreateRequest
     */
    'answer': UserSurveyAnswerUpdateRequestAnswer;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyAnswerCreateRequest
     */
    'question': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserSurveyAnswerCreateRequest
     */
    'answered': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyAnswerCreateRequest
     */
    'notes'?: string;
}
/**
 * 
 * @export
 * @interface UserSurveyAnswerDto
 */
export interface UserSurveyAnswerDto {
    /**
     * 
     * @type {UserSurveyAnswerDtoAnswer}
     * @memberof UserSurveyAnswerDto
     */
    'answer': UserSurveyAnswerDtoAnswer | null;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyAnswerDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyAnswerDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyAnswerDto
     */
    'userSurvey': string;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyAnswerDto
     */
    'survey': string;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyAnswerDto
     */
    'user': string;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyAnswerDto
     */
    'question': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserSurveyAnswerDto
     */
    'answered': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyAnswerDto
     */
    'notes': string | null;
}
/**
 * @type UserSurveyAnswerDtoAnswer
 * @export
 */
export type UserSurveyAnswerDtoAnswer = Array<string> | boolean | string;

/**
 * 
 * @export
 * @interface UserSurveyAnswerUpdateRequest
 */
export interface UserSurveyAnswerUpdateRequest {
    /**
     * 
     * @type {UserSurveyAnswerUpdateRequestAnswer}
     * @memberof UserSurveyAnswerUpdateRequest
     */
    'answer'?: UserSurveyAnswerUpdateRequestAnswer;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyAnswerUpdateRequest
     */
    'question': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserSurveyAnswerUpdateRequest
     */
    'answered'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyAnswerUpdateRequest
     */
    'notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyAnswerUpdateRequest
     */
    'userProp'?: string;
}
/**
 * @type UserSurveyAnswerUpdateRequestAnswer
 * @export
 */
export type UserSurveyAnswerUpdateRequestAnswer = Array<string> | boolean | string;

/**
 * 
 * @export
 * @interface UserSurveyAppListResponse
 */
export interface UserSurveyAppListResponse {
    /**
     * 
     * @type {Array<SurveyQuestionDto>}
     * @memberof UserSurveyAppListResponse
     */
    'questions': Array<SurveyQuestionDto>;
    /**
     * 
     * @type {Array<UserSurveyWithAnswersPopulatedUser>}
     * @memberof UserSurveyAppListResponse
     */
    'data': Array<UserSurveyWithAnswersPopulatedUser>;
    /**
     * 
     * @type {number}
     * @memberof UserSurveyAppListResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface UserSurveyDto
 */
export interface UserSurveyDto {
    /**
     * 
     * @type {string}
     * @memberof UserSurveyDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyDto
     */
    'survey': string;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyDto
     */
    'user': string;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyDto
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyDto
     */
    'notes': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyDto
     */
    'submittedAt': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserSurveyDto
     */
    'deleted': boolean;
    /**
     * 
     * @type {Array<UserSurveyAnswerDto>}
     * @memberof UserSurveyDto
     */
    'answers': Array<UserSurveyAnswerDto>;
}
/**
 * 
 * @export
 * @interface UserSurveyResponse
 */
export interface UserSurveyResponse {
    /**
     * 
     * @type {UserSurveyDto}
     * @memberof UserSurveyResponse
     */
    'userSurvey': UserSurveyDto;
}
/**
 * 
 * @export
 * @interface UserSurveySubmitRequest
 */
export interface UserSurveySubmitRequest {
    /**
     * 
     * @type {Array<UserSurveyAnswerCreateRequest>}
     * @memberof UserSurveySubmitRequest
     */
    'answers': Array<UserSurveyAnswerCreateRequest>;
}
/**
 * 
 * @export
 * @interface UserSurveyUpdateRequest
 */
export interface UserSurveyUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof UserSurveyUpdateRequest
     */
    'status'?: UserSurveyUpdateRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyUpdateRequest
     */
    'notes'?: string;
    /**
     * 
     * @type {Array<UserSurveyAnswerUpdateRequest>}
     * @memberof UserSurveyUpdateRequest
     */
    'answers'?: Array<UserSurveyAnswerUpdateRequest>;
}

export const UserSurveyUpdateRequestStatusEnum = {
    Draft: 'draft',
    Submitted: 'submitted'
} as const;

export type UserSurveyUpdateRequestStatusEnum = typeof UserSurveyUpdateRequestStatusEnum[keyof typeof UserSurveyUpdateRequestStatusEnum];

/**
 * 
 * @export
 * @interface UserSurveyWithAnswersPopulatedUser
 */
export interface UserSurveyWithAnswersPopulatedUser {
    /**
     * 
     * @type {string}
     * @memberof UserSurveyWithAnswersPopulatedUser
     */
    'survey': string;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyWithAnswersPopulatedUser
     */
    'userSurvey': string;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyWithAnswersPopulatedUser
     */
    'user': string;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyWithAnswersPopulatedUser
     */
    'type': UserSurveyWithAnswersPopulatedUserTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyWithAnswersPopulatedUser
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyWithAnswersPopulatedUser
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyWithAnswersPopulatedUser
     */
    'submittedAt': string;
    /**
     * 
     * @type {Array<UserSurveyAnswerDto>}
     * @memberof UserSurveyWithAnswersPopulatedUser
     */
    'answers': Array<UserSurveyAnswerDto>;
}

export const UserSurveyWithAnswersPopulatedUserTypeEnum = {
    Draft: 'draft',
    Member: 'member',
    Prospect: 'prospect',
    Registered: 'registered'
} as const;

export type UserSurveyWithAnswersPopulatedUserTypeEnum = typeof UserSurveyWithAnswersPopulatedUserTypeEnum[keyof typeof UserSurveyWithAnswersPopulatedUserTypeEnum];

/**
 * 
 * @export
 * @interface UserSurveysExportRequest
 */
export interface UserSurveysExportRequest {
    /**
     * 
     * @type {string}
     * @memberof UserSurveysExportRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserSurveysExportRequest
     */
    'surveyId': string;
}
/**
 * 
 * @export
 * @interface WheelCreateRequest
 */
export interface WheelCreateRequest {
    /**
     * 
     * @type {Array<WheelOptionCreateRequest>}
     * @memberof WheelCreateRequest
     */
    'wheelOptions': Array<WheelOptionCreateRequest>;
}
/**
 * 
 * @export
 * @interface WheelDtlResponse
 */
export interface WheelDtlResponse {
    /**
     * 
     * @type {WheelDto}
     * @memberof WheelDtlResponse
     */
    'wheel': WheelDto;
}
/**
 * 
 * @export
 * @interface WheelDto
 */
export interface WheelDto {
    /**
     * 
     * @type {string}
     * @memberof WheelDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WheelDto
     */
    'app': string;
    /**
     * 
     * @type {Array<WheelOptionDto>}
     * @memberof WheelDto
     */
    'wheelOptions': Array<WheelOptionDto>;
    /**
     * 
     * @type {string}
     * @memberof WheelDto
     */
    'status': WheelDtoStatusEnum;
}

export const WheelDtoStatusEnum = {
    Pending: 'pending',
    Active: 'active'
} as const;

export type WheelDtoStatusEnum = typeof WheelDtoStatusEnum[keyof typeof WheelDtoStatusEnum];

/**
 * 
 * @export
 * @interface WheelOptionCreateRequest
 */
export interface WheelOptionCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof WheelOptionCreateRequest
     */
    'rewardType': WheelOptionCreateRequestRewardTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof WheelOptionCreateRequest
     */
    'value': number;
    /**
     * 
     * @type {number}
     * @memberof WheelOptionCreateRequest
     */
    'probability': number;
    /**
     * 
     * @type {string}
     * @memberof WheelOptionCreateRequest
     */
    'skuId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WheelOptionCreateRequest
     */
    'productId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WheelOptionCreateRequest
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof WheelOptionCreateRequest
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof WheelOptionCreateRequest
     */
    'minPurchaseAmount'?: number;
}

export const WheelOptionCreateRequestRewardTypeEnum = {
    Percentage: 'percentage',
    Monetary: 'monetary',
    FreeShipping: 'freeShipping',
    FreeSku: 'freeSku',
    Bogo: 'BOGO',
    Mix: 'mix'
} as const;

export type WheelOptionCreateRequestRewardTypeEnum = typeof WheelOptionCreateRequestRewardTypeEnum[keyof typeof WheelOptionCreateRequestRewardTypeEnum];

/**
 * 
 * @export
 * @interface WheelOptionDto
 */
export interface WheelOptionDto {
    /**
     * 
     * @type {string}
     * @memberof WheelOptionDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WheelOptionDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof WheelOptionDto
     */
    'wheelId': string;
    /**
     * 
     * @type {string}
     * @memberof WheelOptionDto
     */
    'rewardType': WheelOptionDtoRewardTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof WheelOptionDto
     */
    'value': number;
    /**
     * 
     * @type {number}
     * @memberof WheelOptionDto
     */
    'probability': number;
    /**
     * 
     * @type {string}
     * @memberof WheelOptionDto
     */
    'skuId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WheelOptionDto
     */
    'productId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WheelOptionDto
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof WheelOptionDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof WheelOptionDto
     */
    'minPurchaseAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof WheelOptionDto
     */
    'externalId'?: string;
}

export const WheelOptionDtoRewardTypeEnum = {
    Percentage: 'percentage',
    Monetary: 'monetary',
    FreeShipping: 'freeShipping',
    FreeSku: 'freeSku',
    Bogo: 'BOGO',
    Mix: 'mix'
} as const;

export type WheelOptionDtoRewardTypeEnum = typeof WheelOptionDtoRewardTypeEnum[keyof typeof WheelOptionDtoRewardTypeEnum];

/**
 * 
 * @export
 * @interface WheelOptionUpdateRequest
 */
export interface WheelOptionUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof WheelOptionUpdateRequest
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof WheelOptionUpdateRequest
     */
    'value'?: number;
    /**
     * 
     * @type {number}
     * @memberof WheelOptionUpdateRequest
     */
    'probability'?: number;
    /**
     * 
     * @type {string}
     * @memberof WheelOptionUpdateRequest
     */
    'skuId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WheelOptionUpdateRequest
     */
    'productId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WheelOptionUpdateRequest
     */
    'image'?: string;
    /**
     * 
     * @type {number}
     * @memberof WheelOptionUpdateRequest
     */
    'minPurchaseAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof WheelOptionUpdateRequest
     */
    'externalId'?: string;
}
/**
 * 
 * @export
 * @interface WheelSpinDto
 */
export interface WheelSpinDto {
    /**
     * 
     * @type {string}
     * @memberof WheelSpinDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WheelSpinDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof WheelSpinDto
     */
    'user'?: string;
    /**
     * 
     * @type {string}
     * @memberof WheelSpinDto
     */
    'wheel': string;
    /**
     * 
     * @type {string}
     * @memberof WheelSpinDto
     */
    'option': string;
    /**
     * 
     * @type {string}
     * @memberof WheelSpinDto
     */
    'status': WheelSpinDtoStatusEnum;
}

export const WheelSpinDtoStatusEnum = {
    Draft: 'draft',
    Active: 'active'
} as const;

export type WheelSpinDtoStatusEnum = typeof WheelSpinDtoStatusEnum[keyof typeof WheelSpinDtoStatusEnum];

/**
 * 
 * @export
 * @interface WheelSpinPopualtedResponse
 */
export interface WheelSpinPopualtedResponse {
    /**
     * 
     * @type {WheelSpinPopulatedDto}
     * @memberof WheelSpinPopualtedResponse
     */
    'wheelSpin': WheelSpinPopulatedDto;
}
/**
 * 
 * @export
 * @interface WheelSpinPopulatedDto
 */
export interface WheelSpinPopulatedDto {
    /**
     * 
     * @type {string}
     * @memberof WheelSpinPopulatedDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WheelSpinPopulatedDto
     */
    'app': string;
    /**
     * 
     * @type {UserDto}
     * @memberof WheelSpinPopulatedDto
     */
    'user'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof WheelSpinPopulatedDto
     */
    'wheel': string;
    /**
     * 
     * @type {WheelOptionDto}
     * @memberof WheelSpinPopulatedDto
     */
    'option': WheelOptionDto;
    /**
     * 
     * @type {string}
     * @memberof WheelSpinPopulatedDto
     */
    'status': WheelSpinPopulatedDtoStatusEnum;
}

export const WheelSpinPopulatedDtoStatusEnum = {
    Draft: 'draft',
    Active: 'active'
} as const;

export type WheelSpinPopulatedDtoStatusEnum = typeof WheelSpinPopulatedDtoStatusEnum[keyof typeof WheelSpinPopulatedDtoStatusEnum];

/**
 * 
 * @export
 * @interface WheelSpinRequest
 */
export interface WheelSpinRequest {
    /**
     * 
     * @type {string}
     * @memberof WheelSpinRequest
     */
    'wheelId': string;
    /**
     * 
     * @type {string}
     * @memberof WheelSpinRequest
     */
    'userId'?: string;
}
/**
 * 
 * @export
 * @interface WheelSpinResponse
 */
export interface WheelSpinResponse {
    /**
     * 
     * @type {WheelSpinDto}
     * @memberof WheelSpinResponse
     */
    'wheelSpin': WheelSpinDto;
}
/**
 * 
 * @export
 * @interface WheelUpdateRequest
 */
export interface WheelUpdateRequest {
    /**
     * 
     * @type {Array<WheelOptionUpdateRequest>}
     * @memberof WheelUpdateRequest
     */
    'wheelOptions'?: Array<WheelOptionUpdateRequest>;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appControllerHealthCheck: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health-check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appControllerHealthCheck(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appControllerHealthCheck(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.appControllerHealthCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appControllerHealthCheck(options?: any): AxiosPromise<void> {
            return localVarFp.appControllerHealthCheck(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public appControllerHealthCheck(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).appControllerHealthCheck(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EventsApi - axios parameter creator
 * @export
 */
export const EventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create user event
         * @param {string} gamixAppId 
         * @param {CreateEventRequest} createEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerCreate: async (gamixAppId: string, createEventRequest: CreateEventRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('eventsControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'createEventRequest' is not null or undefined
            assertParamExists('eventsControllerCreate', 'createEventRequest', createEventRequest)
            const localVarPath = `/v2/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEventRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get global categories statistics
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerGetGlobalCategoryStat: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('eventsControllerGetGlobalCategoryStat', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/events/global-categories/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Events-based Metrics
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerGetMetrics: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('eventsControllerGetMetrics', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/events/metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create user event
         * @param {string} gamixAppId 
         * @param {CreateEventRequest} createEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventsControllerCreate(gamixAppId: string, createEventRequest: CreateEventRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventsControllerCreate(gamixAppId, createEventRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.eventsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get global categories statistics
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventsControllerGetGlobalCategoryStat(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlobalCategoriesStatResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventsControllerGetGlobalCategoryStat(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.eventsControllerGetGlobalCategoryStat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Events-based Metrics
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventsControllerGetMetrics(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventsControllerGetMetrics(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.eventsControllerGetMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create user event
         * @param {string} gamixAppId 
         * @param {CreateEventRequest} createEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerCreate(gamixAppId: string, createEventRequest: CreateEventRequest, options?: any): AxiosPromise<void> {
            return localVarFp.eventsControllerCreate(gamixAppId, createEventRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get global categories statistics
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerGetGlobalCategoryStat(gamixAppId: string, options?: any): AxiosPromise<GlobalCategoriesStatResponse> {
            return localVarFp.eventsControllerGetGlobalCategoryStat(gamixAppId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Events-based Metrics
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsControllerGetMetrics(gamixAppId: string, options?: any): AxiosPromise<void> {
            return localVarFp.eventsControllerGetMetrics(gamixAppId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI {
    /**
     * 
     * @summary Create user event
     * @param {string} gamixAppId 
     * @param {CreateEventRequest} createEventRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public eventsControllerCreate(gamixAppId: string, createEventRequest: CreateEventRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).eventsControllerCreate(gamixAppId, createEventRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get global categories statistics
     * @param {string} gamixAppId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public eventsControllerGetGlobalCategoryStat(gamixAppId: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).eventsControllerGetGlobalCategoryStat(gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Events-based Metrics
     * @param {string} gamixAppId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public eventsControllerGetMetrics(gamixAppId: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).eventsControllerGetMetrics(gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FiltersApi - axios parameter creator
 * @export
 */
export const FiltersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new filter
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerCreate: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('filtersControllerCreate', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/events/flows/filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get filter by id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerGet: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('filtersControllerGet', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('filtersControllerGet', 'id', id)
            const localVarPath = `/v2/events/flows/filters/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all filters
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerList: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('filtersControllerList', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/events/flows/filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a filter
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerUpdate: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('filtersControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('filtersControllerUpdate', 'id', id)
            const localVarPath = `/v2/events/flows/filters/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FiltersApi - functional programming interface
 * @export
 */
export const FiltersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FiltersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new filter
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filtersControllerCreate(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filtersControllerCreate(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FiltersApi.filtersControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get filter by id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filtersControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filtersControllerGet(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FiltersApi.filtersControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all filters
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filtersControllerList(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FiltersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filtersControllerList(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FiltersApi.filtersControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a filter
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filtersControllerUpdate(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filtersControllerUpdate(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FiltersApi.filtersControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FiltersApi - factory interface
 * @export
 */
export const FiltersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FiltersApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new filter
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerCreate(gamixAppId: string, options?: any): AxiosPromise<FilterResponse> {
            return localVarFp.filtersControllerCreate(gamixAppId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get filter by id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerGet(gamixAppId: string, id: string, options?: any): AxiosPromise<FilterResponse> {
            return localVarFp.filtersControllerGet(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all filters
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerList(gamixAppId: string, options?: any): AxiosPromise<FiltersResponse> {
            return localVarFp.filtersControllerList(gamixAppId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a filter
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filtersControllerUpdate(gamixAppId: string, id: string, options?: any): AxiosPromise<FilterResponse> {
            return localVarFp.filtersControllerUpdate(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FiltersApi - object-oriented interface
 * @export
 * @class FiltersApi
 * @extends {BaseAPI}
 */
export class FiltersApi extends BaseAPI {
    /**
     * 
     * @summary Create a new filter
     * @param {string} gamixAppId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiltersApi
     */
    public filtersControllerCreate(gamixAppId: string, options?: RawAxiosRequestConfig) {
        return FiltersApiFp(this.configuration).filtersControllerCreate(gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get filter by id
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiltersApi
     */
    public filtersControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return FiltersApiFp(this.configuration).filtersControllerGet(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all filters
     * @param {string} gamixAppId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiltersApi
     */
    public filtersControllerList(gamixAppId: string, options?: RawAxiosRequestConfig) {
        return FiltersApiFp(this.configuration).filtersControllerList(gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a filter
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiltersApi
     */
    public filtersControllerUpdate(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return FiltersApiFp(this.configuration).filtersControllerUpdate(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FlowActionsApi - axios parameter creator
 * @export
 */
export const FlowActionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary create Flow Action
         * @param {string} gamixAppId 
         * @param {ActionCreateRequest} actionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionsControllerCreate: async (gamixAppId: string, actionCreateRequest: ActionCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('actionsControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'actionCreateRequest' is not null or undefined
            assertParamExists('actionsControllerCreate', 'actionCreateRequest', actionCreateRequest)
            const localVarPath = `/v2/events/flows/actions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actionCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get Flow Action
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionsControllerGet: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('actionsControllerGet', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('actionsControllerGet', 'id', id)
            const localVarPath = `/v2/events/flows/actions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list Flow Actions
         * @param {string} gamixAppId 
         * @param {string} flow 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionsControllerListPerFlow: async (gamixAppId: string, flow: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('actionsControllerListPerFlow', 'gamixAppId', gamixAppId)
            // verify required parameter 'flow' is not null or undefined
            assertParamExists('actionsControllerListPerFlow', 'flow', flow)
            const localVarPath = `/v2/events/flows/actions/flow/{flow}`
                .replace(`{${"flow"}}`, encodeURIComponent(String(flow)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FlowActionsApi - functional programming interface
 * @export
 */
export const FlowActionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FlowActionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary create Flow Action
         * @param {string} gamixAppId 
         * @param {ActionCreateRequest} actionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionsControllerCreate(gamixAppId: string, actionCreateRequest: ActionCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionsControllerCreate(gamixAppId, actionCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowActionsApi.actionsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get Flow Action
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionsControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionsControllerGet(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowActionsApi.actionsControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list Flow Actions
         * @param {string} gamixAppId 
         * @param {string} flow 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionsControllerListPerFlow(gamixAppId: string, flow: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionsControllerListPerFlow(gamixAppId, flow, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowActionsApi.actionsControllerListPerFlow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FlowActionsApi - factory interface
 * @export
 */
export const FlowActionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FlowActionsApiFp(configuration)
    return {
        /**
         * 
         * @summary create Flow Action
         * @param {string} gamixAppId 
         * @param {ActionCreateRequest} actionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionsControllerCreate(gamixAppId: string, actionCreateRequest: ActionCreateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.actionsControllerCreate(gamixAppId, actionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get Flow Action
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionsControllerGet(gamixAppId: string, id: string, options?: any): AxiosPromise<ActionResponse> {
            return localVarFp.actionsControllerGet(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list Flow Actions
         * @param {string} gamixAppId 
         * @param {string} flow 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionsControllerListPerFlow(gamixAppId: string, flow: string, options?: any): AxiosPromise<ActionsResponse> {
            return localVarFp.actionsControllerListPerFlow(gamixAppId, flow, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FlowActionsApi - object-oriented interface
 * @export
 * @class FlowActionsApi
 * @extends {BaseAPI}
 */
export class FlowActionsApi extends BaseAPI {
    /**
     * 
     * @summary create Flow Action
     * @param {string} gamixAppId 
     * @param {ActionCreateRequest} actionCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowActionsApi
     */
    public actionsControllerCreate(gamixAppId: string, actionCreateRequest: ActionCreateRequest, options?: RawAxiosRequestConfig) {
        return FlowActionsApiFp(this.configuration).actionsControllerCreate(gamixAppId, actionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get Flow Action
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowActionsApi
     */
    public actionsControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return FlowActionsApiFp(this.configuration).actionsControllerGet(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list Flow Actions
     * @param {string} gamixAppId 
     * @param {string} flow 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowActionsApi
     */
    public actionsControllerListPerFlow(gamixAppId: string, flow: string, options?: RawAxiosRequestConfig) {
        return FlowActionsApiFp(this.configuration).actionsControllerListPerFlow(gamixAppId, flow, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FlowsApi - axios parameter creator
 * @export
 */
export const FlowsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create flow
         * @param {string} gamixAppId 
         * @param {CreateFlowRequest} createFlowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flowsControllerCreate: async (gamixAppId: string, createFlowRequest: CreateFlowRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('flowsControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'createFlowRequest' is not null or undefined
            assertParamExists('flowsControllerCreate', 'createFlowRequest', createFlowRequest)
            const localVarPath = `/v2/events/flows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFlowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete flow
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flowsControllerDelete: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('flowsControllerDelete', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('flowsControllerDelete', 'id', id)
            const localVarPath = `/v2/events/flows/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get flow
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flowsControllerGet: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('flowsControllerGet', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('flowsControllerGet', 'id', id)
            const localVarPath = `/v2/events/flows/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update flow
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {UpdateFlowRequest} updateFlowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flowsControllerUpdate: async (gamixAppId: string, id: string, updateFlowRequest: UpdateFlowRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('flowsControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('flowsControllerUpdate', 'id', id)
            // verify required parameter 'updateFlowRequest' is not null or undefined
            assertParamExists('flowsControllerUpdate', 'updateFlowRequest', updateFlowRequest)
            const localVarPath = `/v2/events/flows/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFlowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FlowsApi - functional programming interface
 * @export
 */
export const FlowsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FlowsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create flow
         * @param {string} gamixAppId 
         * @param {CreateFlowRequest} createFlowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async flowsControllerCreate(gamixAppId: string, createFlowRequest: CreateFlowRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.flowsControllerCreate(gamixAppId, createFlowRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowsApi.flowsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete flow
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async flowsControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.flowsControllerDelete(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowsApi.flowsControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get flow
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async flowsControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.flowsControllerGet(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowsApi.flowsControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update flow
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {UpdateFlowRequest} updateFlowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async flowsControllerUpdate(gamixAppId: string, id: string, updateFlowRequest: UpdateFlowRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.flowsControllerUpdate(gamixAppId, id, updateFlowRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowsApi.flowsControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FlowsApi - factory interface
 * @export
 */
export const FlowsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FlowsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create flow
         * @param {string} gamixAppId 
         * @param {CreateFlowRequest} createFlowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flowsControllerCreate(gamixAppId: string, createFlowRequest: CreateFlowRequest, options?: any): AxiosPromise<FlowResponse> {
            return localVarFp.flowsControllerCreate(gamixAppId, createFlowRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete flow
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flowsControllerDelete(gamixAppId: string, id: string, options?: any): AxiosPromise<FlowResponse> {
            return localVarFp.flowsControllerDelete(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get flow
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flowsControllerGet(gamixAppId: string, id: string, options?: any): AxiosPromise<FlowResponse> {
            return localVarFp.flowsControllerGet(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update flow
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {UpdateFlowRequest} updateFlowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flowsControllerUpdate(gamixAppId: string, id: string, updateFlowRequest: UpdateFlowRequest, options?: any): AxiosPromise<FlowResponse> {
            return localVarFp.flowsControllerUpdate(gamixAppId, id, updateFlowRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FlowsApi - object-oriented interface
 * @export
 * @class FlowsApi
 * @extends {BaseAPI}
 */
export class FlowsApi extends BaseAPI {
    /**
     * 
     * @summary Create flow
     * @param {string} gamixAppId 
     * @param {CreateFlowRequest} createFlowRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    public flowsControllerCreate(gamixAppId: string, createFlowRequest: CreateFlowRequest, options?: RawAxiosRequestConfig) {
        return FlowsApiFp(this.configuration).flowsControllerCreate(gamixAppId, createFlowRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete flow
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    public flowsControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return FlowsApiFp(this.configuration).flowsControllerDelete(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get flow
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    public flowsControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return FlowsApiFp(this.configuration).flowsControllerGet(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update flow
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {UpdateFlowRequest} updateFlowRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    public flowsControllerUpdate(gamixAppId: string, id: string, updateFlowRequest: UpdateFlowRequest, options?: RawAxiosRequestConfig) {
        return FlowsApiFp(this.configuration).flowsControllerUpdate(gamixAppId, id, updateFlowRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LegacyEventsApi - axios parameter creator
 * @export
 */
export const LegacyEventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This API can be used only by the backend internally to track restricted evnets
         * @summary Create Restricted User Event
         * @param {string} gamixAppId 
         * @param {RestrictedEventCreateRequest} restrictedEventCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyEventsControllerCreate: async (gamixAppId: string, restrictedEventCreateRequest: RestrictedEventCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('legacyEventsControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'restrictedEventCreateRequest' is not null or undefined
            assertParamExists('legacyEventsControllerCreate', 'restrictedEventCreateRequest', restrictedEventCreateRequest)
            const localVarPath = `/v2/legacy-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(restrictedEventCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This API can be used by the frontend to create custom events
         * @summary Create User Event
         * @param {string} gamixAppId 
         * @param {NonRestrictedEventCreateRequest} nonRestrictedEventCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyEventsControllerCreatePublicEvent: async (gamixAppId: string, nonRestrictedEventCreateRequest: NonRestrictedEventCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('legacyEventsControllerCreatePublicEvent', 'gamixAppId', gamixAppId)
            // verify required parameter 'nonRestrictedEventCreateRequest' is not null or undefined
            assertParamExists('legacyEventsControllerCreatePublicEvent', 'nonRestrictedEventCreateRequest', nonRestrictedEventCreateRequest)
            const localVarPath = `/v2/legacy-events/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nonRestrictedEventCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Event
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyEventsControllerGet: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('legacyEventsControllerGet', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('legacyEventsControllerGet', 'id', id)
            const localVarPath = `/v2/legacy-events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Events
         * @param {string} gamixAppId 
         * @param {string} [type] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyEventsControllerList: async (gamixAppId: string, type?: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('legacyEventsControllerList', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/legacy-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegacyEventsApi - functional programming interface
 * @export
 */
export const LegacyEventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LegacyEventsApiAxiosParamCreator(configuration)
    return {
        /**
         * This API can be used only by the backend internally to track restricted evnets
         * @summary Create Restricted User Event
         * @param {string} gamixAppId 
         * @param {RestrictedEventCreateRequest} restrictedEventCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async legacyEventsControllerCreate(gamixAppId: string, restrictedEventCreateRequest: RestrictedEventCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegacyEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.legacyEventsControllerCreate(gamixAppId, restrictedEventCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegacyEventsApi.legacyEventsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This API can be used by the frontend to create custom events
         * @summary Create User Event
         * @param {string} gamixAppId 
         * @param {NonRestrictedEventCreateRequest} nonRestrictedEventCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async legacyEventsControllerCreatePublicEvent(gamixAppId: string, nonRestrictedEventCreateRequest: NonRestrictedEventCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegacyEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.legacyEventsControllerCreatePublicEvent(gamixAppId, nonRestrictedEventCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegacyEventsApi.legacyEventsControllerCreatePublicEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Event
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async legacyEventsControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegacyEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.legacyEventsControllerGet(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegacyEventsApi.legacyEventsControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Events
         * @param {string} gamixAppId 
         * @param {string} [type] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async legacyEventsControllerList(gamixAppId: string, type?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegacyEventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.legacyEventsControllerList(gamixAppId, type, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegacyEventsApi.legacyEventsControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LegacyEventsApi - factory interface
 * @export
 */
export const LegacyEventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LegacyEventsApiFp(configuration)
    return {
        /**
         * This API can be used only by the backend internally to track restricted evnets
         * @summary Create Restricted User Event
         * @param {string} gamixAppId 
         * @param {RestrictedEventCreateRequest} restrictedEventCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyEventsControllerCreate(gamixAppId: string, restrictedEventCreateRequest: RestrictedEventCreateRequest, options?: any): AxiosPromise<LegacyEventResponse> {
            return localVarFp.legacyEventsControllerCreate(gamixAppId, restrictedEventCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This API can be used by the frontend to create custom events
         * @summary Create User Event
         * @param {string} gamixAppId 
         * @param {NonRestrictedEventCreateRequest} nonRestrictedEventCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyEventsControllerCreatePublicEvent(gamixAppId: string, nonRestrictedEventCreateRequest: NonRestrictedEventCreateRequest, options?: any): AxiosPromise<LegacyEventResponse> {
            return localVarFp.legacyEventsControllerCreatePublicEvent(gamixAppId, nonRestrictedEventCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Event
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyEventsControllerGet(gamixAppId: string, id: string, options?: any): AxiosPromise<LegacyEventResponse> {
            return localVarFp.legacyEventsControllerGet(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Events
         * @param {string} gamixAppId 
         * @param {string} [type] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyEventsControllerList(gamixAppId: string, type?: string, limit?: number, skip?: number, options?: any): AxiosPromise<LegacyEventsResponse> {
            return localVarFp.legacyEventsControllerList(gamixAppId, type, limit, skip, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegacyEventsApi - object-oriented interface
 * @export
 * @class LegacyEventsApi
 * @extends {BaseAPI}
 */
export class LegacyEventsApi extends BaseAPI {
    /**
     * This API can be used only by the backend internally to track restricted evnets
     * @summary Create Restricted User Event
     * @param {string} gamixAppId 
     * @param {RestrictedEventCreateRequest} restrictedEventCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyEventsApi
     */
    public legacyEventsControllerCreate(gamixAppId: string, restrictedEventCreateRequest: RestrictedEventCreateRequest, options?: RawAxiosRequestConfig) {
        return LegacyEventsApiFp(this.configuration).legacyEventsControllerCreate(gamixAppId, restrictedEventCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This API can be used by the frontend to create custom events
     * @summary Create User Event
     * @param {string} gamixAppId 
     * @param {NonRestrictedEventCreateRequest} nonRestrictedEventCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyEventsApi
     */
    public legacyEventsControllerCreatePublicEvent(gamixAppId: string, nonRestrictedEventCreateRequest: NonRestrictedEventCreateRequest, options?: RawAxiosRequestConfig) {
        return LegacyEventsApiFp(this.configuration).legacyEventsControllerCreatePublicEvent(gamixAppId, nonRestrictedEventCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Event
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyEventsApi
     */
    public legacyEventsControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return LegacyEventsApiFp(this.configuration).legacyEventsControllerGet(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Events
     * @param {string} gamixAppId 
     * @param {string} [type] 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyEventsApi
     */
    public legacyEventsControllerList(gamixAppId: string, type?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return LegacyEventsApiFp(this.configuration).legacyEventsControllerList(gamixAppId, type, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LinkReferralsApi - axios parameter creator
 * @export
 */
export const LinkReferralsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get User Link Referral
         * @param {string} gamixAppId 
         * @param {string} appReferral 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkReferralsControllerGet: async (gamixAppId: string, appReferral: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('linkReferralsControllerGet', 'gamixAppId', gamixAppId)
            // verify required parameter 'appReferral' is not null or undefined
            assertParamExists('linkReferralsControllerGet', 'appReferral', appReferral)
            const localVarPath = `/v2/link-referrals/{appReferral}`
                .replace(`{${"appReferral"}}`, encodeURIComponent(String(appReferral)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LinkReferralsApi - functional programming interface
 * @export
 */
export const LinkReferralsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LinkReferralsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get User Link Referral
         * @param {string} gamixAppId 
         * @param {string} appReferral 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkReferralsControllerGet(gamixAppId: string, appReferral: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LinkReferralResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkReferralsControllerGet(gamixAppId, appReferral, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LinkReferralsApi.linkReferralsControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LinkReferralsApi - factory interface
 * @export
 */
export const LinkReferralsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LinkReferralsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get User Link Referral
         * @param {string} gamixAppId 
         * @param {string} appReferral 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkReferralsControllerGet(gamixAppId: string, appReferral: string, options?: any): AxiosPromise<LinkReferralResponse> {
            return localVarFp.linkReferralsControllerGet(gamixAppId, appReferral, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LinkReferralsApi - object-oriented interface
 * @export
 * @class LinkReferralsApi
 * @extends {BaseAPI}
 */
export class LinkReferralsApi extends BaseAPI {
    /**
     * 
     * @summary Get User Link Referral
     * @param {string} gamixAppId 
     * @param {string} appReferral 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LinkReferralsApi
     */
    public linkReferralsControllerGet(gamixAppId: string, appReferral: string, options?: RawAxiosRequestConfig) {
        return LinkReferralsApiFp(this.configuration).linkReferralsControllerGet(gamixAppId, appReferral, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReferralsApi - axios parameter creator
 * @export
 */
export const ReferralsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Referral
         * @param {string} gamixAppId 
         * @param {ReferralCreateRequest} referralCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsControllerCreate: async (gamixAppId: string, referralCreateRequest: ReferralCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('referralsControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'referralCreateRequest' is not null or undefined
            assertParamExists('referralsControllerCreate', 'referralCreateRequest', referralCreateRequest)
            const localVarPath = `/v2/referrals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(referralCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Referral
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsControllerDelete: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('referralsControllerDelete', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('referralsControllerDelete', 'id', id)
            const localVarPath = `/v2/referrals/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Referral
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsControllerGet: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('referralsControllerGet', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('referralsControllerGet', 'id', id)
            const localVarPath = `/v2/referrals/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Referrals
         * @param {string} gamixAppId 
         * @param {string} [events] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsControllerList: async (gamixAppId: string, events?: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('referralsControllerList', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/referrals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (events !== undefined) {
                localVarQueryParameter['events'] = events;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Referral
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {ReferralUpdateRequest} referralUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsControllerUpdate: async (gamixAppId: string, id: string, referralUpdateRequest: ReferralUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('referralsControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('referralsControllerUpdate', 'id', id)
            // verify required parameter 'referralUpdateRequest' is not null or undefined
            assertParamExists('referralsControllerUpdate', 'referralUpdateRequest', referralUpdateRequest)
            const localVarPath = `/v2/referrals/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(referralUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReferralsApi - functional programming interface
 * @export
 */
export const ReferralsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReferralsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Referral
         * @param {string} gamixAppId 
         * @param {ReferralCreateRequest} referralCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async referralsControllerCreate(gamixAppId: string, referralCreateRequest: ReferralCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferralResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.referralsControllerCreate(gamixAppId, referralCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralsApi.referralsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Referral
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async referralsControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.referralsControllerDelete(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralsApi.referralsControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Referral
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async referralsControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferralResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.referralsControllerGet(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralsApi.referralsControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Referrals
         * @param {string} gamixAppId 
         * @param {string} [events] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async referralsControllerList(gamixAppId: string, events?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferralsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.referralsControllerList(gamixAppId, events, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralsApi.referralsControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Referral
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {ReferralUpdateRequest} referralUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async referralsControllerUpdate(gamixAppId: string, id: string, referralUpdateRequest: ReferralUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferralResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.referralsControllerUpdate(gamixAppId, id, referralUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralsApi.referralsControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReferralsApi - factory interface
 * @export
 */
export const ReferralsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReferralsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Referral
         * @param {string} gamixAppId 
         * @param {ReferralCreateRequest} referralCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsControllerCreate(gamixAppId: string, referralCreateRequest: ReferralCreateRequest, options?: any): AxiosPromise<ReferralResponse> {
            return localVarFp.referralsControllerCreate(gamixAppId, referralCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Referral
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsControllerDelete(gamixAppId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.referralsControllerDelete(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Referral
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsControllerGet(gamixAppId: string, id: string, options?: any): AxiosPromise<ReferralResponse> {
            return localVarFp.referralsControllerGet(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Referrals
         * @param {string} gamixAppId 
         * @param {string} [events] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsControllerList(gamixAppId: string, events?: string, limit?: number, skip?: number, options?: any): AxiosPromise<ReferralsResponse> {
            return localVarFp.referralsControllerList(gamixAppId, events, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Referral
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {ReferralUpdateRequest} referralUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsControllerUpdate(gamixAppId: string, id: string, referralUpdateRequest: ReferralUpdateRequest, options?: any): AxiosPromise<ReferralResponse> {
            return localVarFp.referralsControllerUpdate(gamixAppId, id, referralUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReferralsApi - object-oriented interface
 * @export
 * @class ReferralsApi
 * @extends {BaseAPI}
 */
export class ReferralsApi extends BaseAPI {
    /**
     * 
     * @summary Create Referral
     * @param {string} gamixAppId 
     * @param {ReferralCreateRequest} referralCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralsApi
     */
    public referralsControllerCreate(gamixAppId: string, referralCreateRequest: ReferralCreateRequest, options?: RawAxiosRequestConfig) {
        return ReferralsApiFp(this.configuration).referralsControllerCreate(gamixAppId, referralCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Referral
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralsApi
     */
    public referralsControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return ReferralsApiFp(this.configuration).referralsControllerDelete(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Referral
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralsApi
     */
    public referralsControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return ReferralsApiFp(this.configuration).referralsControllerGet(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Referrals
     * @param {string} gamixAppId 
     * @param {string} [events] 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralsApi
     */
    public referralsControllerList(gamixAppId: string, events?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return ReferralsApiFp(this.configuration).referralsControllerList(gamixAppId, events, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Referral
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {ReferralUpdateRequest} referralUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralsApi
     */
    public referralsControllerUpdate(gamixAppId: string, id: string, referralUpdateRequest: ReferralUpdateRequest, options?: RawAxiosRequestConfig) {
        return ReferralsApiFp(this.configuration).referralsControllerUpdate(gamixAppId, id, referralUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SegmentUsersApi - axios parameter creator
 * @export
 */
export const SegmentUsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentUsersControllerCreateTable: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/events-svc/segment-users/table`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} gamixAppId 
         * @param {string} segmentId 
         * @param {number} [batchSize] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentUsersControllerListSegmentUsersQuery: async (gamixAppId: string, segmentId: string, batchSize?: number, nextPageToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('segmentUsersControllerListSegmentUsersQuery', 'gamixAppId', gamixAppId)
            // verify required parameter 'segmentId' is not null or undefined
            assertParamExists('segmentUsersControllerListSegmentUsersQuery', 'segmentId', segmentId)
            const localVarPath = `/v2/events-svc/segment-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (segmentId !== undefined) {
                localVarQueryParameter['segmentId'] = segmentId;
            }

            if (batchSize !== undefined) {
                localVarQueryParameter['batchSize'] = batchSize;
            }

            if (nextPageToken !== undefined) {
                localVarQueryParameter['nextPageToken'] = nextPageToken;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SegmentUsersApi - functional programming interface
 * @export
 */
export const SegmentUsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SegmentUsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async segmentUsersControllerCreateTable(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.segmentUsersControllerCreateTable(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SegmentUsersApi.segmentUsersControllerCreateTable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} gamixAppId 
         * @param {string} segmentId 
         * @param {number} [batchSize] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async segmentUsersControllerListSegmentUsersQuery(gamixAppId: string, segmentId: string, batchSize?: number, nextPageToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SegmentUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.segmentUsersControllerListSegmentUsersQuery(gamixAppId, segmentId, batchSize, nextPageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SegmentUsersApi.segmentUsersControllerListSegmentUsersQuery']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SegmentUsersApi - factory interface
 * @export
 */
export const SegmentUsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SegmentUsersApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentUsersControllerCreateTable(options?: any): AxiosPromise<void> {
            return localVarFp.segmentUsersControllerCreateTable(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} gamixAppId 
         * @param {string} segmentId 
         * @param {number} [batchSize] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentUsersControllerListSegmentUsersQuery(gamixAppId: string, segmentId: string, batchSize?: number, nextPageToken?: string, options?: any): AxiosPromise<SegmentUsersResponse> {
            return localVarFp.segmentUsersControllerListSegmentUsersQuery(gamixAppId, segmentId, batchSize, nextPageToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SegmentUsersApi - object-oriented interface
 * @export
 * @class SegmentUsersApi
 * @extends {BaseAPI}
 */
export class SegmentUsersApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SegmentUsersApi
     */
    public segmentUsersControllerCreateTable(options?: RawAxiosRequestConfig) {
        return SegmentUsersApiFp(this.configuration).segmentUsersControllerCreateTable(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} gamixAppId 
     * @param {string} segmentId 
     * @param {number} [batchSize] 
     * @param {string} [nextPageToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SegmentUsersApi
     */
    public segmentUsersControllerListSegmentUsersQuery(gamixAppId: string, segmentId: string, batchSize?: number, nextPageToken?: string, options?: RawAxiosRequestConfig) {
        return SegmentUsersApiFp(this.configuration).segmentUsersControllerListSegmentUsersQuery(gamixAppId, segmentId, batchSize, nextPageToken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SegmentsApi - axios parameter creator
 * @export
 */
export const SegmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Segments
         * @param {string} gamixAppId 
         * @param {SegmentRequest} segmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentsControllerCreateSegment: async (gamixAppId: string, segmentRequest: SegmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('segmentsControllerCreateSegment', 'gamixAppId', gamixAppId)
            // verify required parameter 'segmentRequest' is not null or undefined
            assertParamExists('segmentsControllerCreateSegment', 'segmentRequest', segmentRequest)
            const localVarPath = `/v2/events-svc/segments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(segmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary evaluate audience By Segments
         * @param {string} gamixAppId 
         * @param {SegmentRequest} segmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentsControllerEvaluateSegment: async (gamixAppId: string, segmentRequest: SegmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('segmentsControllerEvaluateSegment', 'gamixAppId', gamixAppId)
            // verify required parameter 'segmentRequest' is not null or undefined
            assertParamExists('segmentsControllerEvaluateSegment', 'segmentRequest', segmentRequest)
            const localVarPath = `/v2/events-svc/segments/evaluate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(segmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get age stats for Segment Users
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentsControllerGetAgeDistribution: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('segmentsControllerGetAgeDistribution', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('segmentsControllerGetAgeDistribution', 'id', id)
            const localVarPath = `/v2/events-svc/segments/{id}/stats/age`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get channel stats for Segment Users
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentsControllerGetChannelDistribution: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('segmentsControllerGetChannelDistribution', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('segmentsControllerGetChannelDistribution', 'id', id)
            const localVarPath = `/v2/events-svc/segments/{id}/stats/channel`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get gender stats for Segment Users
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentsControllerGetGenderDistribution: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('segmentsControllerGetGenderDistribution', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('segmentsControllerGetGenderDistribution', 'id', id)
            const localVarPath = `/v2/events-svc/segments/{id}/stats/gender`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get location stats for Segment Users
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentsControllerGetLocationDistribution: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('segmentsControllerGetLocationDistribution', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('segmentsControllerGetLocationDistribution', 'id', id)
            const localVarPath = `/v2/events-svc/segments/{id}/stats/location`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get RFM group stats for Segment Users
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentsControllerGetRfmDistribution: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('segmentsControllerGetRfmDistribution', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('segmentsControllerGetRfmDistribution', 'id', id)
            const localVarPath = `/v2/events-svc/segments/{id}/stats/rfm`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get audience statsBy Segments
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {Array<string>} apps 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentsControllerGetStatsBySegmentId: async (gamixAppId: string, id: string, apps: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('segmentsControllerGetStatsBySegmentId', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('segmentsControllerGetStatsBySegmentId', 'id', id)
            // verify required parameter 'apps' is not null or undefined
            assertParamExists('segmentsControllerGetStatsBySegmentId', 'apps', apps)
            const localVarPath = `/v2/events-svc/segments/{id}/stats`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apps) {
                localVarQueryParameter['apps'] = apps;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Segments
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentsControllerList: async (gamixAppId: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('segmentsControllerList', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/events-svc/segments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Segment
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {UpdateSegmentRequest} updateSegmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentsControllerUpdateSegment: async (gamixAppId: string, id: string, updateSegmentRequest: UpdateSegmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('segmentsControllerUpdateSegment', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('segmentsControllerUpdateSegment', 'id', id)
            // verify required parameter 'updateSegmentRequest' is not null or undefined
            assertParamExists('segmentsControllerUpdateSegment', 'updateSegmentRequest', updateSegmentRequest)
            const localVarPath = `/v2/events-svc/segments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSegmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SegmentsApi - functional programming interface
 * @export
 */
export const SegmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SegmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Segments
         * @param {string} gamixAppId 
         * @param {SegmentRequest} segmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async segmentsControllerCreateSegment(gamixAppId: string, segmentRequest: SegmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SegmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.segmentsControllerCreateSegment(gamixAppId, segmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SegmentsApi.segmentsControllerCreateSegment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary evaluate audience By Segments
         * @param {string} gamixAppId 
         * @param {SegmentRequest} segmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async segmentsControllerEvaluateSegment(gamixAppId: string, segmentRequest: SegmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountBySegmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.segmentsControllerEvaluateSegment(gamixAppId, segmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SegmentsApi.segmentsControllerEvaluateSegment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get age stats for Segment Users
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async segmentsControllerGetAgeDistribution(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgeDistributionItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.segmentsControllerGetAgeDistribution(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SegmentsApi.segmentsControllerGetAgeDistribution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get channel stats for Segment Users
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async segmentsControllerGetChannelDistribution(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChannelDistributionItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.segmentsControllerGetChannelDistribution(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SegmentsApi.segmentsControllerGetChannelDistribution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get gender stats for Segment Users
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async segmentsControllerGetGenderDistribution(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GenderDistributionItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.segmentsControllerGetGenderDistribution(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SegmentsApi.segmentsControllerGetGenderDistribution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get location stats for Segment Users
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async segmentsControllerGetLocationDistribution(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocationDistributionItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.segmentsControllerGetLocationDistribution(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SegmentsApi.segmentsControllerGetLocationDistribution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get RFM group stats for Segment Users
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async segmentsControllerGetRfmDistribution(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RfmDistributionItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.segmentsControllerGetRfmDistribution(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SegmentsApi.segmentsControllerGetRfmDistribution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get audience statsBy Segments
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {Array<string>} apps 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async segmentsControllerGetStatsBySegmentId(gamixAppId: string, id: string, apps: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountBySegmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.segmentsControllerGetStatsBySegmentId(gamixAppId, id, apps, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SegmentsApi.segmentsControllerGetStatsBySegmentId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Segments
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async segmentsControllerList(gamixAppId: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SegmentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.segmentsControllerList(gamixAppId, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SegmentsApi.segmentsControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Segment
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {UpdateSegmentRequest} updateSegmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async segmentsControllerUpdateSegment(gamixAppId: string, id: string, updateSegmentRequest: UpdateSegmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SegmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.segmentsControllerUpdateSegment(gamixAppId, id, updateSegmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SegmentsApi.segmentsControllerUpdateSegment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SegmentsApi - factory interface
 * @export
 */
export const SegmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SegmentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Segments
         * @param {string} gamixAppId 
         * @param {SegmentRequest} segmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentsControllerCreateSegment(gamixAppId: string, segmentRequest: SegmentRequest, options?: any): AxiosPromise<SegmentResponse> {
            return localVarFp.segmentsControllerCreateSegment(gamixAppId, segmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary evaluate audience By Segments
         * @param {string} gamixAppId 
         * @param {SegmentRequest} segmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentsControllerEvaluateSegment(gamixAppId: string, segmentRequest: SegmentRequest, options?: any): AxiosPromise<CountBySegmentResponse> {
            return localVarFp.segmentsControllerEvaluateSegment(gamixAppId, segmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get age stats for Segment Users
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentsControllerGetAgeDistribution(gamixAppId: string, id: string, options?: any): AxiosPromise<Array<AgeDistributionItem>> {
            return localVarFp.segmentsControllerGetAgeDistribution(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get channel stats for Segment Users
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentsControllerGetChannelDistribution(gamixAppId: string, id: string, options?: any): AxiosPromise<Array<ChannelDistributionItem>> {
            return localVarFp.segmentsControllerGetChannelDistribution(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get gender stats for Segment Users
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentsControllerGetGenderDistribution(gamixAppId: string, id: string, options?: any): AxiosPromise<Array<GenderDistributionItem>> {
            return localVarFp.segmentsControllerGetGenderDistribution(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get location stats for Segment Users
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentsControllerGetLocationDistribution(gamixAppId: string, id: string, options?: any): AxiosPromise<Array<LocationDistributionItem>> {
            return localVarFp.segmentsControllerGetLocationDistribution(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get RFM group stats for Segment Users
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentsControllerGetRfmDistribution(gamixAppId: string, id: string, options?: any): AxiosPromise<Array<RfmDistributionItem>> {
            return localVarFp.segmentsControllerGetRfmDistribution(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get audience statsBy Segments
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {Array<string>} apps 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentsControllerGetStatsBySegmentId(gamixAppId: string, id: string, apps: Array<string>, options?: any): AxiosPromise<CountBySegmentResponse> {
            return localVarFp.segmentsControllerGetStatsBySegmentId(gamixAppId, id, apps, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Segments
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentsControllerList(gamixAppId: string, limit?: number, skip?: number, options?: any): AxiosPromise<SegmentsResponse> {
            return localVarFp.segmentsControllerList(gamixAppId, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Segment
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {UpdateSegmentRequest} updateSegmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        segmentsControllerUpdateSegment(gamixAppId: string, id: string, updateSegmentRequest: UpdateSegmentRequest, options?: any): AxiosPromise<SegmentResponse> {
            return localVarFp.segmentsControllerUpdateSegment(gamixAppId, id, updateSegmentRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SegmentsApi - object-oriented interface
 * @export
 * @class SegmentsApi
 * @extends {BaseAPI}
 */
export class SegmentsApi extends BaseAPI {
    /**
     * 
     * @summary Create Segments
     * @param {string} gamixAppId 
     * @param {SegmentRequest} segmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SegmentsApi
     */
    public segmentsControllerCreateSegment(gamixAppId: string, segmentRequest: SegmentRequest, options?: RawAxiosRequestConfig) {
        return SegmentsApiFp(this.configuration).segmentsControllerCreateSegment(gamixAppId, segmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary evaluate audience By Segments
     * @param {string} gamixAppId 
     * @param {SegmentRequest} segmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SegmentsApi
     */
    public segmentsControllerEvaluateSegment(gamixAppId: string, segmentRequest: SegmentRequest, options?: RawAxiosRequestConfig) {
        return SegmentsApiFp(this.configuration).segmentsControllerEvaluateSegment(gamixAppId, segmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get age stats for Segment Users
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SegmentsApi
     */
    public segmentsControllerGetAgeDistribution(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return SegmentsApiFp(this.configuration).segmentsControllerGetAgeDistribution(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get channel stats for Segment Users
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SegmentsApi
     */
    public segmentsControllerGetChannelDistribution(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return SegmentsApiFp(this.configuration).segmentsControllerGetChannelDistribution(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get gender stats for Segment Users
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SegmentsApi
     */
    public segmentsControllerGetGenderDistribution(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return SegmentsApiFp(this.configuration).segmentsControllerGetGenderDistribution(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get location stats for Segment Users
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SegmentsApi
     */
    public segmentsControllerGetLocationDistribution(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return SegmentsApiFp(this.configuration).segmentsControllerGetLocationDistribution(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get RFM group stats for Segment Users
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SegmentsApi
     */
    public segmentsControllerGetRfmDistribution(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return SegmentsApiFp(this.configuration).segmentsControllerGetRfmDistribution(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get audience statsBy Segments
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {Array<string>} apps 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SegmentsApi
     */
    public segmentsControllerGetStatsBySegmentId(gamixAppId: string, id: string, apps: Array<string>, options?: RawAxiosRequestConfig) {
        return SegmentsApiFp(this.configuration).segmentsControllerGetStatsBySegmentId(gamixAppId, id, apps, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Segments
     * @param {string} gamixAppId 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SegmentsApi
     */
    public segmentsControllerList(gamixAppId: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return SegmentsApiFp(this.configuration).segmentsControllerList(gamixAppId, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Segment
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {UpdateSegmentRequest} updateSegmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SegmentsApi
     */
    public segmentsControllerUpdateSegment(gamixAppId: string, id: string, updateSegmentRequest: UpdateSegmentRequest, options?: RawAxiosRequestConfig) {
        return SegmentsApiFp(this.configuration).segmentsControllerUpdateSegment(gamixAppId, id, updateSegmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SpinTheWheelApi - axios parameter creator
 * @export
 */
export const SpinTheWheelApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Spin the wheel
         * @param {string} gamixAppId 
         * @param {WheelSpinRequest} wheelSpinRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wheelSpinsControllerCreate: async (gamixAppId: string, wheelSpinRequest: WheelSpinRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('wheelSpinsControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'wheelSpinRequest' is not null or undefined
            assertParamExists('wheelSpinsControllerCreate', 'wheelSpinRequest', wheelSpinRequest)
            const localVarPath = `/v2/events-svc/spin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(wheelSpinRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get spins
         * @param {string} gamixAppId 
         * @param {string} wheelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wheelSpinsControllerGetByUser: async (gamixAppId: string, wheelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('wheelSpinsControllerGetByUser', 'gamixAppId', gamixAppId)
            // verify required parameter 'wheelId' is not null or undefined
            assertParamExists('wheelSpinsControllerGetByUser', 'wheelId', wheelId)
            const localVarPath = `/v2/events-svc/spin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (wheelId !== undefined) {
                localVarQueryParameter['wheelId'] = wheelId;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Process the spin
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wheelSpinsControllerProcessSpin: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('wheelSpinsControllerProcessSpin', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('wheelSpinsControllerProcessSpin', 'id', id)
            const localVarPath = `/v2/events-svc/spin/process-spin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SpinTheWheelApi - functional programming interface
 * @export
 */
export const SpinTheWheelApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SpinTheWheelApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Spin the wheel
         * @param {string} gamixAppId 
         * @param {WheelSpinRequest} wheelSpinRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wheelSpinsControllerCreate(gamixAppId: string, wheelSpinRequest: WheelSpinRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WheelSpinPopualtedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wheelSpinsControllerCreate(gamixAppId, wheelSpinRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpinTheWheelApi.wheelSpinsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get spins
         * @param {string} gamixAppId 
         * @param {string} wheelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wheelSpinsControllerGetByUser(gamixAppId: string, wheelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WheelSpinResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wheelSpinsControllerGetByUser(gamixAppId, wheelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpinTheWheelApi.wheelSpinsControllerGetByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Process the spin
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wheelSpinsControllerProcessSpin(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WheelSpinPopualtedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wheelSpinsControllerProcessSpin(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpinTheWheelApi.wheelSpinsControllerProcessSpin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SpinTheWheelApi - factory interface
 * @export
 */
export const SpinTheWheelApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SpinTheWheelApiFp(configuration)
    return {
        /**
         * 
         * @summary Spin the wheel
         * @param {string} gamixAppId 
         * @param {WheelSpinRequest} wheelSpinRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wheelSpinsControllerCreate(gamixAppId: string, wheelSpinRequest: WheelSpinRequest, options?: any): AxiosPromise<WheelSpinPopualtedResponse> {
            return localVarFp.wheelSpinsControllerCreate(gamixAppId, wheelSpinRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get spins
         * @param {string} gamixAppId 
         * @param {string} wheelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wheelSpinsControllerGetByUser(gamixAppId: string, wheelId: string, options?: any): AxiosPromise<WheelSpinResponse> {
            return localVarFp.wheelSpinsControllerGetByUser(gamixAppId, wheelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Process the spin
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wheelSpinsControllerProcessSpin(gamixAppId: string, id: string, options?: any): AxiosPromise<WheelSpinPopualtedResponse> {
            return localVarFp.wheelSpinsControllerProcessSpin(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SpinTheWheelApi - object-oriented interface
 * @export
 * @class SpinTheWheelApi
 * @extends {BaseAPI}
 */
export class SpinTheWheelApi extends BaseAPI {
    /**
     * 
     * @summary Spin the wheel
     * @param {string} gamixAppId 
     * @param {WheelSpinRequest} wheelSpinRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpinTheWheelApi
     */
    public wheelSpinsControllerCreate(gamixAppId: string, wheelSpinRequest: WheelSpinRequest, options?: RawAxiosRequestConfig) {
        return SpinTheWheelApiFp(this.configuration).wheelSpinsControllerCreate(gamixAppId, wheelSpinRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get spins
     * @param {string} gamixAppId 
     * @param {string} wheelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpinTheWheelApi
     */
    public wheelSpinsControllerGetByUser(gamixAppId: string, wheelId: string, options?: RawAxiosRequestConfig) {
        return SpinTheWheelApiFp(this.configuration).wheelSpinsControllerGetByUser(gamixAppId, wheelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Process the spin
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpinTheWheelApi
     */
    public wheelSpinsControllerProcessSpin(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return SpinTheWheelApiFp(this.configuration).wheelSpinsControllerProcessSpin(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SurveysApi - axios parameter creator
 * @export
 */
export const SurveysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Survey
         * @param {string} gamixAppId 
         * @param {AppSurveyCreateRequest} appSurveyCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appSurveysControllerCreate: async (gamixAppId: string, appSurveyCreateRequest: AppSurveyCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appSurveysControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'appSurveyCreateRequest' is not null or undefined
            assertParamExists('appSurveysControllerCreate', 'appSurveyCreateRequest', appSurveyCreateRequest)
            const localVarPath = `/v2/surveys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appSurveyCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Survey
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appSurveysControllerDelete: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appSurveysControllerDelete', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('appSurveysControllerDelete', 'id', id)
            const localVarPath = `/v2/surveys/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Survey
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appSurveysControllerGet: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appSurveysControllerGet', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('appSurveysControllerGet', 'id', id)
            const localVarPath = `/v2/surveys/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Surveys
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appSurveysControllerList: async (gamixAppId: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appSurveysControllerList', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/surveys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Survey
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {AppSurveyUpdateRequest} appSurveyUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appSurveysControllerUpdate: async (gamixAppId: string, id: string, appSurveyUpdateRequest: AppSurveyUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appSurveysControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('appSurveysControllerUpdate', 'id', id)
            // verify required parameter 'appSurveyUpdateRequest' is not null or undefined
            assertParamExists('appSurveysControllerUpdate', 'appSurveyUpdateRequest', appSurveyUpdateRequest)
            const localVarPath = `/v2/surveys/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appSurveyUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurveysApi - functional programming interface
 * @export
 */
export const SurveysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SurveysApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Survey
         * @param {string} gamixAppId 
         * @param {AppSurveyCreateRequest} appSurveyCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appSurveysControllerCreate(gamixAppId: string, appSurveyCreateRequest: AppSurveyCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppSurveyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appSurveysControllerCreate(gamixAppId, appSurveyCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveysApi.appSurveysControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Survey
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appSurveysControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appSurveysControllerDelete(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveysApi.appSurveysControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Survey
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appSurveysControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppSurveyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appSurveysControllerGet(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveysApi.appSurveysControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Surveys
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appSurveysControllerList(gamixAppId: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppSurveysResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appSurveysControllerList(gamixAppId, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveysApi.appSurveysControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Survey
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {AppSurveyUpdateRequest} appSurveyUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appSurveysControllerUpdate(gamixAppId: string, id: string, appSurveyUpdateRequest: AppSurveyUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppSurveyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appSurveysControllerUpdate(gamixAppId, id, appSurveyUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveysApi.appSurveysControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SurveysApi - factory interface
 * @export
 */
export const SurveysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SurveysApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Survey
         * @param {string} gamixAppId 
         * @param {AppSurveyCreateRequest} appSurveyCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appSurveysControllerCreate(gamixAppId: string, appSurveyCreateRequest: AppSurveyCreateRequest, options?: any): AxiosPromise<AppSurveyResponse> {
            return localVarFp.appSurveysControllerCreate(gamixAppId, appSurveyCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Survey
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appSurveysControllerDelete(gamixAppId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.appSurveysControllerDelete(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Survey
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appSurveysControllerGet(gamixAppId: string, id: string, options?: any): AxiosPromise<AppSurveyResponse> {
            return localVarFp.appSurveysControllerGet(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Surveys
         * @param {string} gamixAppId 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appSurveysControllerList(gamixAppId: string, limit?: number, skip?: number, options?: any): AxiosPromise<AppSurveysResponse> {
            return localVarFp.appSurveysControllerList(gamixAppId, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Survey
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {AppSurveyUpdateRequest} appSurveyUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appSurveysControllerUpdate(gamixAppId: string, id: string, appSurveyUpdateRequest: AppSurveyUpdateRequest, options?: any): AxiosPromise<AppSurveyResponse> {
            return localVarFp.appSurveysControllerUpdate(gamixAppId, id, appSurveyUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SurveysApi - object-oriented interface
 * @export
 * @class SurveysApi
 * @extends {BaseAPI}
 */
export class SurveysApi extends BaseAPI {
    /**
     * 
     * @summary Create Survey
     * @param {string} gamixAppId 
     * @param {AppSurveyCreateRequest} appSurveyCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public appSurveysControllerCreate(gamixAppId: string, appSurveyCreateRequest: AppSurveyCreateRequest, options?: RawAxiosRequestConfig) {
        return SurveysApiFp(this.configuration).appSurveysControllerCreate(gamixAppId, appSurveyCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Survey
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public appSurveysControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return SurveysApiFp(this.configuration).appSurveysControllerDelete(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Survey
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public appSurveysControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return SurveysApiFp(this.configuration).appSurveysControllerGet(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Surveys
     * @param {string} gamixAppId 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public appSurveysControllerList(gamixAppId: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return SurveysApiFp(this.configuration).appSurveysControllerList(gamixAppId, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Survey
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {AppSurveyUpdateRequest} appSurveyUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    public appSurveysControllerUpdate(gamixAppId: string, id: string, appSurveyUpdateRequest: AppSurveyUpdateRequest, options?: RawAxiosRequestConfig) {
        return SurveysApiFp(this.configuration).appSurveysControllerUpdate(gamixAppId, id, appSurveyUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserReferralsApi - axios parameter creator
 * @export
 */
export const UserReferralsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get User Referral
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userReferralsControllerGet: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('userReferralsControllerGet', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userReferralsControllerGet', 'id', id)
            const localVarPath = `/v2/user-referrals/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get User Referral By Referee
         * @param {string} gamixAppId 
         * @param {string} refereeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userReferralsControllerGetByRefereeId: async (gamixAppId: string, refereeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('userReferralsControllerGetByRefereeId', 'gamixAppId', gamixAppId)
            // verify required parameter 'refereeId' is not null or undefined
            assertParamExists('userReferralsControllerGetByRefereeId', 'refereeId', refereeId)
            const localVarPath = `/v2/user-referrals/referee/{refereeId}`
                .replace(`{${"refereeId"}}`, encodeURIComponent(String(refereeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Invite User
         * @param {string} gamixAppId 
         * @param {string} appReferral 
         * @param {UserReferralInvitation} userReferralInvitation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userReferralsControllerInvite: async (gamixAppId: string, appReferral: string, userReferralInvitation: UserReferralInvitation, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('userReferralsControllerInvite', 'gamixAppId', gamixAppId)
            // verify required parameter 'appReferral' is not null or undefined
            assertParamExists('userReferralsControllerInvite', 'appReferral', appReferral)
            // verify required parameter 'userReferralInvitation' is not null or undefined
            assertParamExists('userReferralsControllerInvite', 'userReferralInvitation', userReferralInvitation)
            const localVarPath = `/v2/user-referrals/{appReferral}/invite`
                .replace(`{${"appReferral"}}`, encodeURIComponent(String(appReferral)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userReferralInvitation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Invite User
         * @param {string} gamixAppId 
         * @param {UserReferralInvitation} userReferralInvitation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userReferralsControllerInviteByCashback: async (gamixAppId: string, userReferralInvitation: UserReferralInvitation, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('userReferralsControllerInviteByCashback', 'gamixAppId', gamixAppId)
            // verify required parameter 'userReferralInvitation' is not null or undefined
            assertParamExists('userReferralsControllerInviteByCashback', 'userReferralInvitation', userReferralInvitation)
            const localVarPath = `/v2/user-referrals/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userReferralInvitation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List User Referrals
         * @param {string} gamixAppId 
         * @param {string} [user] 
         * @param {string} [referral] 
         * @param {UserReferralsControllerListStatusEnum} [status] 
         * @param {string} [createdAt] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userReferralsControllerList: async (gamixAppId: string, user?: string, referral?: string, status?: UserReferralsControllerListStatusEnum, createdAt?: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('userReferralsControllerList', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/user-referrals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }

            if (referral !== undefined) {
                localVarQueryParameter['referral'] = referral;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (createdAt !== undefined) {
                localVarQueryParameter['createdAt'] = createdAt;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserReferralsApi - functional programming interface
 * @export
 */
export const UserReferralsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserReferralsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get User Referral
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userReferralsControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserReferralResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userReferralsControllerGet(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserReferralsApi.userReferralsControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get User Referral By Referee
         * @param {string} gamixAppId 
         * @param {string} refereeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userReferralsControllerGetByRefereeId(gamixAppId: string, refereeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserReferralResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userReferralsControllerGetByRefereeId(gamixAppId, refereeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserReferralsApi.userReferralsControllerGetByRefereeId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Invite User
         * @param {string} gamixAppId 
         * @param {string} appReferral 
         * @param {UserReferralInvitation} userReferralInvitation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userReferralsControllerInvite(gamixAppId: string, appReferral: string, userReferralInvitation: UserReferralInvitation, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserReferralResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userReferralsControllerInvite(gamixAppId, appReferral, userReferralInvitation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserReferralsApi.userReferralsControllerInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Invite User
         * @param {string} gamixAppId 
         * @param {UserReferralInvitation} userReferralInvitation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userReferralsControllerInviteByCashback(gamixAppId: string, userReferralInvitation: UserReferralInvitation, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserReferralResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userReferralsControllerInviteByCashback(gamixAppId, userReferralInvitation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserReferralsApi.userReferralsControllerInviteByCashback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List User Referrals
         * @param {string} gamixAppId 
         * @param {string} [user] 
         * @param {string} [referral] 
         * @param {UserReferralsControllerListStatusEnum} [status] 
         * @param {string} [createdAt] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userReferralsControllerList(gamixAppId: string, user?: string, referral?: string, status?: UserReferralsControllerListStatusEnum, createdAt?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserReferralsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userReferralsControllerList(gamixAppId, user, referral, status, createdAt, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserReferralsApi.userReferralsControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserReferralsApi - factory interface
 * @export
 */
export const UserReferralsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserReferralsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get User Referral
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userReferralsControllerGet(gamixAppId: string, id: string, options?: any): AxiosPromise<UserReferralResponse> {
            return localVarFp.userReferralsControllerGet(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get User Referral By Referee
         * @param {string} gamixAppId 
         * @param {string} refereeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userReferralsControllerGetByRefereeId(gamixAppId: string, refereeId: string, options?: any): AxiosPromise<UserReferralResponse> {
            return localVarFp.userReferralsControllerGetByRefereeId(gamixAppId, refereeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Invite User
         * @param {string} gamixAppId 
         * @param {string} appReferral 
         * @param {UserReferralInvitation} userReferralInvitation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userReferralsControllerInvite(gamixAppId: string, appReferral: string, userReferralInvitation: UserReferralInvitation, options?: any): AxiosPromise<UserReferralResponse> {
            return localVarFp.userReferralsControllerInvite(gamixAppId, appReferral, userReferralInvitation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Invite User
         * @param {string} gamixAppId 
         * @param {UserReferralInvitation} userReferralInvitation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userReferralsControllerInviteByCashback(gamixAppId: string, userReferralInvitation: UserReferralInvitation, options?: any): AxiosPromise<UserReferralResponse> {
            return localVarFp.userReferralsControllerInviteByCashback(gamixAppId, userReferralInvitation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List User Referrals
         * @param {string} gamixAppId 
         * @param {string} [user] 
         * @param {string} [referral] 
         * @param {UserReferralsControllerListStatusEnum} [status] 
         * @param {string} [createdAt] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userReferralsControllerList(gamixAppId: string, user?: string, referral?: string, status?: UserReferralsControllerListStatusEnum, createdAt?: string, limit?: number, skip?: number, options?: any): AxiosPromise<UserReferralsResponse> {
            return localVarFp.userReferralsControllerList(gamixAppId, user, referral, status, createdAt, limit, skip, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserReferralsApi - object-oriented interface
 * @export
 * @class UserReferralsApi
 * @extends {BaseAPI}
 */
export class UserReferralsApi extends BaseAPI {
    /**
     * 
     * @summary Get User Referral
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserReferralsApi
     */
    public userReferralsControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return UserReferralsApiFp(this.configuration).userReferralsControllerGet(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get User Referral By Referee
     * @param {string} gamixAppId 
     * @param {string} refereeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserReferralsApi
     */
    public userReferralsControllerGetByRefereeId(gamixAppId: string, refereeId: string, options?: RawAxiosRequestConfig) {
        return UserReferralsApiFp(this.configuration).userReferralsControllerGetByRefereeId(gamixAppId, refereeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Invite User
     * @param {string} gamixAppId 
     * @param {string} appReferral 
     * @param {UserReferralInvitation} userReferralInvitation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserReferralsApi
     */
    public userReferralsControllerInvite(gamixAppId: string, appReferral: string, userReferralInvitation: UserReferralInvitation, options?: RawAxiosRequestConfig) {
        return UserReferralsApiFp(this.configuration).userReferralsControllerInvite(gamixAppId, appReferral, userReferralInvitation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Invite User
     * @param {string} gamixAppId 
     * @param {UserReferralInvitation} userReferralInvitation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserReferralsApi
     */
    public userReferralsControllerInviteByCashback(gamixAppId: string, userReferralInvitation: UserReferralInvitation, options?: RawAxiosRequestConfig) {
        return UserReferralsApiFp(this.configuration).userReferralsControllerInviteByCashback(gamixAppId, userReferralInvitation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List User Referrals
     * @param {string} gamixAppId 
     * @param {string} [user] 
     * @param {string} [referral] 
     * @param {UserReferralsControllerListStatusEnum} [status] 
     * @param {string} [createdAt] 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserReferralsApi
     */
    public userReferralsControllerList(gamixAppId: string, user?: string, referral?: string, status?: UserReferralsControllerListStatusEnum, createdAt?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return UserReferralsApiFp(this.configuration).userReferralsControllerList(gamixAppId, user, referral, status, createdAt, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const UserReferralsControllerListStatusEnum = {
    Draft: 'draft',
    Active: 'active',
    Completed: 'completed'
} as const;
export type UserReferralsControllerListStatusEnum = typeof UserReferralsControllerListStatusEnum[keyof typeof UserReferralsControllerListStatusEnum];


/**
 * UserSurveysApi - axios parameter creator
 * @export
 */
export const UserSurveysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary export userSurveys data
         * @param {string} gamixAppId 
         * @param {UserSurveysExportRequest} userSurveysExportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSurveysControllerExportUserSurveys: async (gamixAppId: string, userSurveysExportRequest: UserSurveysExportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('userSurveysControllerExportUserSurveys', 'gamixAppId', gamixAppId)
            // verify required parameter 'userSurveysExportRequest' is not null or undefined
            assertParamExists('userSurveysControllerExportUserSurveys', 'userSurveysExportRequest', userSurveysExportRequest)
            const localVarPath = `/v2/user-surveys/export/userSurveys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userSurveysExportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get User Survey By Survey
         * @param {string} gamixAppId 
         * @param {string} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSurveysControllerGetBySurvey: async (gamixAppId: string, surveyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('userSurveysControllerGetBySurvey', 'gamixAppId', gamixAppId)
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('userSurveysControllerGetBySurvey', 'surveyId', surveyId)
            const localVarPath = `/v2/user-surveys/surveys/{surveyId}`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all app userSurveys paginated
         * @param {string} gamixAppId 
         * @param {number} limit 
         * @param {number} skip 
         * @param {string} surveyId 
         * @param {string} [sort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSurveysControllerListAppUserSurveys: async (gamixAppId: string, limit: number, skip: number, surveyId: string, sort?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('userSurveysControllerListAppUserSurveys', 'gamixAppId', gamixAppId)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('userSurveysControllerListAppUserSurveys', 'limit', limit)
            // verify required parameter 'skip' is not null or undefined
            assertParamExists('userSurveysControllerListAppUserSurveys', 'skip', skip)
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('userSurveysControllerListAppUserSurveys', 'surveyId', surveyId)
            const localVarPath = `/v2/user-surveys/app/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (surveyId !== undefined) {
                localVarQueryParameter['surveyId'] = surveyId;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit User Survey
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {UserSurveyUpdateRequest} userSurveyUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSurveysControllerSubmit: async (gamixAppId: string, id: string, userSurveyUpdateRequest: UserSurveyUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('userSurveysControllerSubmit', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userSurveysControllerSubmit', 'id', id)
            // verify required parameter 'userSurveyUpdateRequest' is not null or undefined
            assertParamExists('userSurveysControllerSubmit', 'userSurveyUpdateRequest', userSurveyUpdateRequest)
            const localVarPath = `/v2/user-surveys/submit/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userSurveyUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit User Survey by User token
         * @param {string} gamixAppId 
         * @param {string} surveyId 
         * @param {UserSurveySubmitRequest} userSurveySubmitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSurveysControllerSubmitByUserToken: async (gamixAppId: string, surveyId: string, userSurveySubmitRequest: UserSurveySubmitRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('userSurveysControllerSubmitByUserToken', 'gamixAppId', gamixAppId)
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('userSurveysControllerSubmitByUserToken', 'surveyId', surveyId)
            // verify required parameter 'userSurveySubmitRequest' is not null or undefined
            assertParamExists('userSurveysControllerSubmitByUserToken', 'userSurveySubmitRequest', userSurveySubmitRequest)
            const localVarPath = `/v2/user-surveys/submit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (surveyId !== undefined) {
                localVarQueryParameter['surveyId'] = surveyId;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userSurveySubmitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update User Survey
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {UserSurveyUpdateRequest} userSurveyUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSurveysControllerUpdate: async (gamixAppId: string, id: string, userSurveyUpdateRequest: UserSurveyUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('userSurveysControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userSurveysControllerUpdate', 'id', id)
            // verify required parameter 'userSurveyUpdateRequest' is not null or undefined
            assertParamExists('userSurveysControllerUpdate', 'userSurveyUpdateRequest', userSurveyUpdateRequest)
            const localVarPath = `/v2/user-surveys/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication userToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userSurveyUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserSurveysApi - functional programming interface
 * @export
 */
export const UserSurveysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserSurveysApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary export userSurveys data
         * @param {string} gamixAppId 
         * @param {UserSurveysExportRequest} userSurveysExportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userSurveysControllerExportUserSurveys(gamixAppId: string, userSurveysExportRequest: UserSurveysExportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userSurveysControllerExportUserSurveys(gamixAppId, userSurveysExportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSurveysApi.userSurveysControllerExportUserSurveys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get User Survey By Survey
         * @param {string} gamixAppId 
         * @param {string} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userSurveysControllerGetBySurvey(gamixAppId: string, surveyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSurveyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userSurveysControllerGetBySurvey(gamixAppId, surveyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSurveysApi.userSurveysControllerGetBySurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all app userSurveys paginated
         * @param {string} gamixAppId 
         * @param {number} limit 
         * @param {number} skip 
         * @param {string} surveyId 
         * @param {string} [sort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userSurveysControllerListAppUserSurveys(gamixAppId: string, limit: number, skip: number, surveyId: string, sort?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSurveyAppListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userSurveysControllerListAppUserSurveys(gamixAppId, limit, skip, surveyId, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSurveysApi.userSurveysControllerListAppUserSurveys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Submit User Survey
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {UserSurveyUpdateRequest} userSurveyUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userSurveysControllerSubmit(gamixAppId: string, id: string, userSurveyUpdateRequest: UserSurveyUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSurveyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userSurveysControllerSubmit(gamixAppId, id, userSurveyUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSurveysApi.userSurveysControllerSubmit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Submit User Survey by User token
         * @param {string} gamixAppId 
         * @param {string} surveyId 
         * @param {UserSurveySubmitRequest} userSurveySubmitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userSurveysControllerSubmitByUserToken(gamixAppId: string, surveyId: string, userSurveySubmitRequest: UserSurveySubmitRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSurveyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userSurveysControllerSubmitByUserToken(gamixAppId, surveyId, userSurveySubmitRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSurveysApi.userSurveysControllerSubmitByUserToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update User Survey
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {UserSurveyUpdateRequest} userSurveyUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userSurveysControllerUpdate(gamixAppId: string, id: string, userSurveyUpdateRequest: UserSurveyUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSurveyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userSurveysControllerUpdate(gamixAppId, id, userSurveyUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSurveysApi.userSurveysControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserSurveysApi - factory interface
 * @export
 */
export const UserSurveysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserSurveysApiFp(configuration)
    return {
        /**
         * 
         * @summary export userSurveys data
         * @param {string} gamixAppId 
         * @param {UserSurveysExportRequest} userSurveysExportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSurveysControllerExportUserSurveys(gamixAppId: string, userSurveysExportRequest: UserSurveysExportRequest, options?: any): AxiosPromise<void> {
            return localVarFp.userSurveysControllerExportUserSurveys(gamixAppId, userSurveysExportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get User Survey By Survey
         * @param {string} gamixAppId 
         * @param {string} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSurveysControllerGetBySurvey(gamixAppId: string, surveyId: string, options?: any): AxiosPromise<UserSurveyResponse> {
            return localVarFp.userSurveysControllerGetBySurvey(gamixAppId, surveyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all app userSurveys paginated
         * @param {string} gamixAppId 
         * @param {number} limit 
         * @param {number} skip 
         * @param {string} surveyId 
         * @param {string} [sort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSurveysControllerListAppUserSurveys(gamixAppId: string, limit: number, skip: number, surveyId: string, sort?: string, options?: any): AxiosPromise<UserSurveyAppListResponse> {
            return localVarFp.userSurveysControllerListAppUserSurveys(gamixAppId, limit, skip, surveyId, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit User Survey
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {UserSurveyUpdateRequest} userSurveyUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSurveysControllerSubmit(gamixAppId: string, id: string, userSurveyUpdateRequest: UserSurveyUpdateRequest, options?: any): AxiosPromise<UserSurveyResponse> {
            return localVarFp.userSurveysControllerSubmit(gamixAppId, id, userSurveyUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit User Survey by User token
         * @param {string} gamixAppId 
         * @param {string} surveyId 
         * @param {UserSurveySubmitRequest} userSurveySubmitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSurveysControllerSubmitByUserToken(gamixAppId: string, surveyId: string, userSurveySubmitRequest: UserSurveySubmitRequest, options?: any): AxiosPromise<UserSurveyResponse> {
            return localVarFp.userSurveysControllerSubmitByUserToken(gamixAppId, surveyId, userSurveySubmitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update User Survey
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {UserSurveyUpdateRequest} userSurveyUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSurveysControllerUpdate(gamixAppId: string, id: string, userSurveyUpdateRequest: UserSurveyUpdateRequest, options?: any): AxiosPromise<UserSurveyResponse> {
            return localVarFp.userSurveysControllerUpdate(gamixAppId, id, userSurveyUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserSurveysApi - object-oriented interface
 * @export
 * @class UserSurveysApi
 * @extends {BaseAPI}
 */
export class UserSurveysApi extends BaseAPI {
    /**
     * 
     * @summary export userSurveys data
     * @param {string} gamixAppId 
     * @param {UserSurveysExportRequest} userSurveysExportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSurveysApi
     */
    public userSurveysControllerExportUserSurveys(gamixAppId: string, userSurveysExportRequest: UserSurveysExportRequest, options?: RawAxiosRequestConfig) {
        return UserSurveysApiFp(this.configuration).userSurveysControllerExportUserSurveys(gamixAppId, userSurveysExportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get User Survey By Survey
     * @param {string} gamixAppId 
     * @param {string} surveyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSurveysApi
     */
    public userSurveysControllerGetBySurvey(gamixAppId: string, surveyId: string, options?: RawAxiosRequestConfig) {
        return UserSurveysApiFp(this.configuration).userSurveysControllerGetBySurvey(gamixAppId, surveyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all app userSurveys paginated
     * @param {string} gamixAppId 
     * @param {number} limit 
     * @param {number} skip 
     * @param {string} surveyId 
     * @param {string} [sort] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSurveysApi
     */
    public userSurveysControllerListAppUserSurveys(gamixAppId: string, limit: number, skip: number, surveyId: string, sort?: string, options?: RawAxiosRequestConfig) {
        return UserSurveysApiFp(this.configuration).userSurveysControllerListAppUserSurveys(gamixAppId, limit, skip, surveyId, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit User Survey
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {UserSurveyUpdateRequest} userSurveyUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSurveysApi
     */
    public userSurveysControllerSubmit(gamixAppId: string, id: string, userSurveyUpdateRequest: UserSurveyUpdateRequest, options?: RawAxiosRequestConfig) {
        return UserSurveysApiFp(this.configuration).userSurveysControllerSubmit(gamixAppId, id, userSurveyUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit User Survey by User token
     * @param {string} gamixAppId 
     * @param {string} surveyId 
     * @param {UserSurveySubmitRequest} userSurveySubmitRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSurveysApi
     */
    public userSurveysControllerSubmitByUserToken(gamixAppId: string, surveyId: string, userSurveySubmitRequest: UserSurveySubmitRequest, options?: RawAxiosRequestConfig) {
        return UserSurveysApiFp(this.configuration).userSurveysControllerSubmitByUserToken(gamixAppId, surveyId, userSurveySubmitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update User Survey
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {UserSurveyUpdateRequest} userSurveyUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSurveysApi
     */
    public userSurveysControllerUpdate(gamixAppId: string, id: string, userSurveyUpdateRequest: UserSurveyUpdateRequest, options?: RawAxiosRequestConfig) {
        return UserSurveysApiFp(this.configuration).userSurveysControllerUpdate(gamixAppId, id, userSurveyUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WheelConfigurationApi - axios parameter creator
 * @export
 */
export const WheelConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Wheel
         * @param {string} gamixAppId 
         * @param {WheelCreateRequest} wheelCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wheelsControllerCreate: async (gamixAppId: string, wheelCreateRequest: WheelCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('wheelsControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'wheelCreateRequest' is not null or undefined
            assertParamExists('wheelsControllerCreate', 'wheelCreateRequest', wheelCreateRequest)
            const localVarPath = `/v2/events/wheel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(wheelCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update wheel By Id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wheelsControllerDelete: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('wheelsControllerDelete', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('wheelsControllerDelete', 'id', id)
            const localVarPath = `/v2/events/wheel/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get wheel By id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wheelsControllerGet: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('wheelsControllerGet', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('wheelsControllerGet', 'id', id)
            const localVarPath = `/v2/events/wheel/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update wheel By Id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {WheelUpdateRequest} wheelUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wheelsControllerUpdate: async (gamixAppId: string, id: string, wheelUpdateRequest: WheelUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('wheelsControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('wheelsControllerUpdate', 'id', id)
            // verify required parameter 'wheelUpdateRequest' is not null or undefined
            assertParamExists('wheelsControllerUpdate', 'wheelUpdateRequest', wheelUpdateRequest)
            const localVarPath = `/v2/events/wheel/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(wheelUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WheelConfigurationApi - functional programming interface
 * @export
 */
export const WheelConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WheelConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Wheel
         * @param {string} gamixAppId 
         * @param {WheelCreateRequest} wheelCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wheelsControllerCreate(gamixAppId: string, wheelCreateRequest: WheelCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WheelDtlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wheelsControllerCreate(gamixAppId, wheelCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WheelConfigurationApi.wheelsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update wheel By Id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wheelsControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wheelsControllerDelete(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WheelConfigurationApi.wheelsControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get wheel By id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wheelsControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WheelDtlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wheelsControllerGet(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WheelConfigurationApi.wheelsControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update wheel By Id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {WheelUpdateRequest} wheelUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wheelsControllerUpdate(gamixAppId: string, id: string, wheelUpdateRequest: WheelUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WheelDtlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wheelsControllerUpdate(gamixAppId, id, wheelUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WheelConfigurationApi.wheelsControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WheelConfigurationApi - factory interface
 * @export
 */
export const WheelConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WheelConfigurationApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Wheel
         * @param {string} gamixAppId 
         * @param {WheelCreateRequest} wheelCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wheelsControllerCreate(gamixAppId: string, wheelCreateRequest: WheelCreateRequest, options?: any): AxiosPromise<WheelDtlResponse> {
            return localVarFp.wheelsControllerCreate(gamixAppId, wheelCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update wheel By Id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wheelsControllerDelete(gamixAppId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.wheelsControllerDelete(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get wheel By id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wheelsControllerGet(gamixAppId: string, id: string, options?: any): AxiosPromise<WheelDtlResponse> {
            return localVarFp.wheelsControllerGet(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update wheel By Id
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {WheelUpdateRequest} wheelUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wheelsControllerUpdate(gamixAppId: string, id: string, wheelUpdateRequest: WheelUpdateRequest, options?: any): AxiosPromise<WheelDtlResponse> {
            return localVarFp.wheelsControllerUpdate(gamixAppId, id, wheelUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WheelConfigurationApi - object-oriented interface
 * @export
 * @class WheelConfigurationApi
 * @extends {BaseAPI}
 */
export class WheelConfigurationApi extends BaseAPI {
    /**
     * 
     * @summary Create Wheel
     * @param {string} gamixAppId 
     * @param {WheelCreateRequest} wheelCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WheelConfigurationApi
     */
    public wheelsControllerCreate(gamixAppId: string, wheelCreateRequest: WheelCreateRequest, options?: RawAxiosRequestConfig) {
        return WheelConfigurationApiFp(this.configuration).wheelsControllerCreate(gamixAppId, wheelCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update wheel By Id
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WheelConfigurationApi
     */
    public wheelsControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return WheelConfigurationApiFp(this.configuration).wheelsControllerDelete(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get wheel By id
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WheelConfigurationApi
     */
    public wheelsControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return WheelConfigurationApiFp(this.configuration).wheelsControllerGet(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update wheel By Id
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {WheelUpdateRequest} wheelUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WheelConfigurationApi
     */
    public wheelsControllerUpdate(gamixAppId: string, id: string, wheelUpdateRequest: WheelUpdateRequest, options?: RawAxiosRequestConfig) {
        return WheelConfigurationApiFp(this.configuration).wheelsControllerUpdate(gamixAppId, id, wheelUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



